import React, { useState, useEffect, useDeferredValue } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { Table, Button, Modal, OverlayTrigger, Tooltip, FormControl, InputGroup, Form, Pagination, ProgressBar, Spinner, Row, Col, Dropdown, DropdownButton } from 'react-bootstrap';
import VehicleForm from './VehicleForm';
import { CircleFill, PlusCircle, PlusCircleFill, InfoCircle, Trash, Wrench, ArrowBarUp, Search, ArrowDownUp, Funnel, FiletypeXlsx, CurrencyDollar, Buildings, CheckCircle, EnvelopeArrowUp, ChevronRight, ChevronDown } from "react-bootstrap-icons";
import { read, utils, writeFile } from 'xlsx';
import { useFirestore } from '../contexts/FirestoreContext';
//import { createTeamsFoldersForVehicles } from '../utils/teamsUtils';
import { sendInternalEmail, makeCsvAttachmentFromVehicles } from '../utils/mailUtils';
import { Timestamp, writeBatch, doc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import Papa from 'papaparse';
import BillOutSheet from './BillOutSheet'; 

// Utility function to get upfitter status description

function VehicleList({ selectedOrder, addButtonActive, allVehicles = false, rowPages = 10, upfitterMode = false, syncSearchWithUrl = true }) {
  const [vehicles, setVehicles] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [vehicleToEdit, setVehicleToEdit] = useState([]);
  const [vehicleToShow, setVehicleToShow] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showBulkEditModal, setShowBulkEditModal] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  const parseStatusesParam = (params) => {
    const raw = params.get('status');
    if (!raw) return [];
    return raw
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  };
  const arraysEqual = (a = [], b = []) => {
    if (a.length !== b.length) return false;
    return a.every((value, index) => value === b[index]);
  };
  const getDefaultStatuses = () => {
    const section = `${(location.pathname || window.location.pathname || '').split('/')[1] || ''}`;
    const defaultStatus = (section === 'vehicles' || section === 'upfitter' || section === 'customer') ? 'Active' : 'All';
    return [defaultStatus];
  };
  const [searchQuery, setSearchQuery] = useState(() => {
    if (syncSearchWithUrl) {
      const params = new URLSearchParams(location.search);
      return params.get('search') || '';
    }
    return '';
  });
  const [searchOperator, setSearchOperator] = useState(() => {
    if (syncSearchWithUrl) {
      const params = new URLSearchParams(location.search);
      const op = (params.get('op') || '').toLowerCase();
      return op === 'and' ? 'and' : 'or';
    }
    return 'or';
  });
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(rowPages);
  const [totalRows, setTotalRows] = useState(0);
  const [showTeamsModal, setShowTeamsModal] = useState(false);
  const [teamsProgress, setTeamsProgress] = useState(0);
  const [teamsLoading, setTeamsLoading] = useState(false);
  const { getData, queryData, updateData, addData, deleteData, getDocument, onSnapshotQueryData, onSnapshotData } = useFirestore();
  const [selectAll, setSelectAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [reload, setReload] = useState(0);
  const [eventCodes, setEventCodes] = useState({});
  const [modelCodes, setModelCodes] = useState({});
  const [colorCodes, setColorCodes] = useState({});
  const [currentImportSheet, setCurrentImportSheet] = useState('');
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc'); // Default direction is 'asc'
  const [salesOrders, setSalesOrders] = useState([]); // Store Sales Orders
  const [customers, setCustomers] = useState([]); // Store Customers
  const [currentVehicleInfo, setCurrentVehicleInfo] = useState(null); // Track current vehicle info
  const [currentVehicleStatus, setCurrentVehicleStatus] = useState(''); // Track if the vehicle is New or Updated
  const [selectedVehicleStatuses, setSelectedVehicleStatuses] = useState(() => {
    const params = new URLSearchParams(location.search);
    const parsed = parseStatusesParam(params);
    if (parsed.length) return parsed;
    return getDefaultStatuses();
  });
  const [selectedVehicleDisplayedStatus, setSelectedVehicleDisplayedStatus] = useState(['All']);
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [etaStartDate, setEtaStartDate] = useState(null);
  const [etaEndDate, setEtaEndDate] = useState(null);
  const [upfitterStatusCodes, setUpfitterStatusCodes] = useState(null);
  const [upfitters, setUpfitters] = useState(null);
  const [paidSelected, setPaidSelected] = useState(false);
  const [showBillOutModal, setShowBillOutModal] = useState(false);
  const [billOutVehicle, setBillOutVehicle] = useState(null);
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [notifyVehicles, setNotifyVehicles] = useState([]); // deduped, VIN-only list
  const [notifyCounts, setNotifyCounts] = useState({ total: 0, withVin: 0, noVin: 0, deduped: 0 });
  const [selectedCustomerNbr, setSelectedCustomerNbr] = useState('');
  const [expandedRows, setExpandedRows] = useState(new Set());

  

  const navigate = useNavigate();
  const deferredSearchQuery = useDeferredValue(searchQuery);
  const deferredSearchOperator = useDeferredValue(searchOperator);
  const [isDataLoading, setIsDataLoading] = useState(true);

  useEffect(() => {
    if (!syncSearchWithUrl) return;
    const params = new URLSearchParams(location.search);
    const paramValue = params.get('search') || '';
    setSearchQuery(prev => (prev === paramValue ? prev : paramValue));
    const op = (params.get('op') || '').toLowerCase();
    setSearchOperator(prev => {
      const next = op === 'and' ? 'and' : 'or';
      return prev === next ? prev : next;
    });
  }, [location.search, syncSearchWithUrl]);

  useEffect(() => {
    if (!syncSearchWithUrl) return;
    const params = new URLSearchParams(location.search);
    const parsed = parseStatusesParam(params);
    const next = parsed.length ? parsed : getDefaultStatuses();
    setSelectedVehicleStatuses((prev) => (arraysEqual(prev, next) ? prev : next));
  }, [location.search, location.pathname, syncSearchWithUrl]);

  const auth = getAuth();
  const currentUser = auth.currentUser;
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    if (!currentUser) return;
    queryData('users', '__name__', '==', currentUser.uid)
      .then(results => {
        if (results.length > 0) {
          setUserProfile(results[0]);
        } else {
          console.warn('No user profile found for', currentUser.uid);
        }
      })
      .catch(console.error);
  }, [currentUser, getData]);

  useEffect(() => {
    setIsDataLoading(true);
    const fetchData = () => {
      const vehicleUnsubscribe = selectedOrder
        ? onSnapshotQueryData('vehicles', 'strSalesOrdNbr', '==', selectedOrder.strSalesOrdNbr, (vehicleData) => {
          setVehicles(vehicleData);
          setIsDataLoading(false);
        })
        : onSnapshotData('vehicles', (vehicleData) => {
          setVehicles(vehicleData);
          setIsDataLoading(false);
        });

      const salesOrderUnsubscribe = onSnapshotData('salesOrders', (salesOrderData) => {
        setSalesOrders(salesOrderData);
      });

      const customerUnsubscribe = onSnapshotData('customers', (customerData) => {
        setCustomers(customerData);
      });

      const upfittersUnsubscribe = onSnapshotData('Upfitters', (upfittersData) => {
        setUpfitters(upfittersData);
      });

      // Clean up the listeners on component unmount
      return () => {
        vehicleUnsubscribe();
        salesOrderUnsubscribe();
        customerUnsubscribe();
        upfittersUnsubscribe();
      };
    };

    fetchData();
  }, [onSnapshotData, onSnapshotQueryData, selectedOrder]);

  useEffect(() => {
    // In upfitter mode, don't subscribe until we know the user's upfitter number
    if (upfitterMode) {
      const n = String(userProfile?.upfitter ?? '').trim();
      if (!n) {
        console.warn(
          "VehicleList: upfitterMode is true, but userProfile.upfitter is not set. Not subscribing to vehicles."
        );
        setIsDataLoading(false);
        return;
      }
    }

    let unsubscribeVehicles = () => { };
    let unsubscribeUpfitters = () => { };
    setIsDataLoading(true);

    if (upfitterMode) {
      // Upfitter mode: include vehicles ONLY if arrUpfitters[*].upfitterNbr matches the user upfitter.
      const myNbr = String(userProfile.upfitter).trim();

      unsubscribeVehicles = onSnapshotData('vehicles', (snapshot) => {
        const filtered = (snapshot || []).filter(v => {
          const list =
            (Array.isArray(v?.arrUpfitters) && v.arrUpfitters) ||
            (Array.isArray(v?.arrUpftters) && v.arrUpftters) ||  // tolerate legacy field name typo
            [];
          return list.some(u => String(u?.upfitterNbr ?? '').trim() === myNbr);
        });
        setVehicles(filtered);
        setIsDataLoading(false);
      });

    } else if (selectedOrder) {
      // Normal order-detail mode
      unsubscribeVehicles = onSnapshotQueryData(
        'vehicles',
        'strSalesOrdNbr', '==',
        selectedOrder.strSalesOrdNbr,
        (snapshot) => {
          setVehicles(snapshot);
          setIsDataLoading(false);
        }
      );

    } else {
      // “All vehicles” mode: include every vehicle, even those assigned to Stock
      unsubscribeVehicles = onSnapshotData('vehicles', (snapshot) => {
        setVehicles(snapshot || []);
        setIsDataLoading(false);
      });
    }

    // Keep upfitters list in all modes
    unsubscribeUpfitters = onSnapshotData('Upfitters', (upfittersData) => {
      setUpfitters(upfittersData);
    });

    return () => {
      try { unsubscribeVehicles && unsubscribeVehicles(); } catch { }
      try { unsubscribeUpfitters && unsubscribeUpfitters(); } catch { }
    };
  }, [
    upfitterMode,
    userProfile?.upfitter,          // filter depends on this
    selectedOrder?.strSalesOrdNbr,  // avoid object identity churn
    onSnapshotData,
    onSnapshotQueryData
  ]);

  useEffect(() => {
    const fetchUpfitterStatusOptions = async () => {
      try {
        const upfitterStatusData = await queryData('eventCodes', 'strFactory', '==', 'UPFITTER');
        setUpfitterStatusCodes(upfitterStatusData);
      } catch (error) {
        console.error('Error fetching upfitter status options:', error);
      }
    };
    fetchUpfitterStatusOptions();
  }, []);

  const toggleExpand = (id) => {
    setExpandedRows(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  // Handle multiple possible field names and shapes safely
  const getUpfitterEntryForUser = (vehicle) => {
    const list =
      vehicle?.arrUpfitters || // preferred
      vehicle?.arrUpftters || // user sample typo
      [];
    const targetNbr = String(userProfile?.upfitter || '').trim();
    if (!targetNbr) return null;
    return list.find(u => String(u?.upfitterNbr || '').trim() === targetNbr) || null;
  };

  // Accept Firestore Timestamp, {seconds, nanoseconds}, Date, ISO string, or falsy
  const normalizeToDate = (val) => {
    if (!val) return null;
    if (typeof val?.toDate === 'function') return val.toDate();
    if (typeof val === 'object' && typeof val.seconds === 'number') return new Date(val.seconds * 1000);
    if (typeof val === 'string') {
      const d = new Date(val);
      return isNaN(d) ? null : d;
    }
    if (val instanceof Date) return isNaN(val) ? null : val;
    return null;
  };

  const formatMaybeDate = (val) => {
    const d = normalizeToDate(val);
    return d ? `${String(d.getUTCMonth() + 1).padStart(2, '0')}/${String(d.getUTCDate()).padStart(2, '0')}/${d.getUTCFullYear()}` : '';
  };

  const getUpfitterGroups = (vehicle) => {
    const list = vehicle?.arrUpfitters || vehicle?.arrUpftters || [];
    return Array.isArray(list) ? list.filter(Boolean) : [];
  };

  const getUpfitterStatusLabelFromEntry = (entry) => {
    const raw =
      (entry?.upfitterStatusText && String(entry.upfitterStatusText).trim()) ||
      getUpfitterStatus(entry?.upfitterStatus) ||
      (entry?.upfitterStatus ? String(entry.upfitterStatus) : '');
    return raw;
  };

  const normalizeUpfitterStatusKey = (label) => {
    const lower = (label || '').toLowerCase();
    if (!lower) return null;
    if (lower.includes('delay')) return 'delayed';
    if (lower.includes('returned')) return 'returned';
    if (lower.includes('ready')) return 'ready';
    if (lower.includes('complete')) return 'complete';
    if (lower.includes('at upfitter') || (lower.includes('upfitter') && lower.includes('at'))) return 'at_upfitter';
    return null;
  };

  const STANDARD_UPFITTER_LABELS = {
    complete: 'Complete',
    delayed: 'Delayed at Upfitter',
    at_upfitter: 'Vehicle at Upfitter',
    ready: 'Ready for Upfitter',
    returned: 'Vehicle Returned from Upfitter',
  };

  const summarizeUpfitters = (vehicle) => {
    const groups = getUpfitterGroups(vehicle).map(entry => {
      const rawLabel = getUpfitterStatusLabelFromEntry(entry);
      const statusKey = normalizeUpfitterStatusKey(rawLabel);
      const statusLabel = statusKey ? (STANDARD_UPFITTER_LABELS[statusKey] || rawLabel) : rawLabel;
      return {
        ...entry,
        statusLabel,
        statusKey,
      };
    });

    const statusesWithKey = groups.filter(entry => entry.statusKey);
    const delayedEntry = statusesWithKey.find(entry => entry.statusKey === 'delayed') || null;
    const atEntry = statusesWithKey.find(entry => entry.statusKey === 'at_upfitter') || null;
    const allComplete = groups.length > 0 && groups.every(entry => entry.statusKey === 'complete');
    const allReady = groups.length > 0 && groups.every(entry => entry.statusKey === 'ready');
    const allReturned = groups.length > 0 && groups.every(entry => entry.statusKey === 'returned');

    let statusKey = null;
    let statusLabel = null;
    let activeEntry = null;

    if (allComplete) {
      statusKey = 'complete';
      statusLabel = STANDARD_UPFITTER_LABELS.complete;
    } else if (delayedEntry) {
      statusKey = 'delayed';
      statusLabel = STANDARD_UPFITTER_LABELS.delayed;
      activeEntry = delayedEntry;
    } else if (atEntry) {
      statusKey = 'at_upfitter';
      statusLabel = STANDARD_UPFITTER_LABELS.at_upfitter;
      activeEntry = atEntry;
    } else if (allReady) {
      statusKey = 'ready';
      statusLabel = STANDARD_UPFITTER_LABELS.ready;
    } else if (allReturned) {
      statusKey = 'returned';
      statusLabel = STANDARD_UPFITTER_LABELS.returned;
    } else if (statusesWithKey.length) {
      statusKey = statusesWithKey[0].statusKey;
      statusLabel = STANDARD_UPFITTER_LABELS[statusKey] || statusesWithKey[0].statusLabel;
      if (statusKey === 'delayed' || statusKey === 'at_upfitter') {
        activeEntry = statusesWithKey[0];
      }
    } else if (groups.length) {
      statusLabel = groups[0].statusLabel;
      statusKey = normalizeUpfitterStatusKey(statusLabel);
    }

    if (!activeEntry && statusKey === 'delayed') {
      activeEntry = delayedEntry;
    }
    if (!activeEntry && statusKey === 'at_upfitter') {
      activeEntry = atEntry;
    }

    const compDates = groups
      .map(entry => normalizeToDate(entry.dtUpfitterComp))
      .filter(Boolean);
    const completeDate = compDates.length === groups.length && groups.length > 0
      ? new Date(Math.max(...compDates.map(d => d.getTime())))
      : null;

    const fallbackLabelRaw = getUpfitterStatus(vehicle?.strUpfitterStatus) || vehicle?.strUpfitterStatus || '';
    const fallbackStatusKey = normalizeUpfitterStatusKey(fallbackLabelRaw);
    const fallbackLabel = fallbackStatusKey ? (STANDARD_UPFITTER_LABELS[fallbackStatusKey] || fallbackLabelRaw) : fallbackLabelRaw;

    return {
      hasUpfitters: groups.length > 0,
      entries: groups,
      label: statusKey ? (STANDARD_UPFITTER_LABELS[statusKey] || statusLabel) : statusLabel,
      statusKey,
      activeEntry,
      sentDate: activeEntry ? activeEntry.dtSentToUpfitter : null,
      etaDate: activeEntry ? activeEntry.dtUpfitterETA : null,
      completeDate,
      fallbackLabel,
      fallbackStatusKey,
      fallbackSentDate: vehicle?.dtSentToUpfitter || null,
      fallbackEtaDate: vehicle?.dtUpfitterETA || null,
      fallbackCompleteDate: vehicle?.dtUpfitterComp || null,
    };
  };

  const getUpfitterColorByKey = (statusKey) => {
    switch (statusKey) {
      case 'complete':
        return 'green';
      case 'delayed':
        return '#c0392b';
      case 'ready':
        return 'orange';
      case 'returned':
        return 'blue';
      case 'at_upfitter':
        return 'blue';
      default:
        return 'blue';
    }
  };

  // Dynamic colSpan so the detail row spans the full table
  const getDetailColSpan = () => {
    let cols = 0;
    // selection/actions column
    cols += 1;
    // SO # (only in allVehicles)
    if (allVehicles) cols += 1;
    // Order #
    cols += 1;
    // DAN (only when addButtonActive)
    if (addButtonActive) cols += 1;
    // Customer Name (only in allVehicles)
    if (allVehicles) cols += 1;
    // Stock/VIN
    cols += 1;
    // Make
    cols += 1;
    // Model
    cols += 1;
    // ETA
    cols += 1;
    // Status
    cols += 1;
    // progress dot
    cols += 1;
    return cols;
  };


  const handleBillOutClick = (vehicle) => {
    setBillOutVehicle(vehicle);
    setShowBillOutModal(true);
  };

  const handleSalesOrderClick = (soNumber) => {
    navigate(`/salesorders?search=${soNumber}`);
  }

  const handleVehicleStatusSelect = (status) => {
    const next = [status]; // Only one status should be selected at a time
    setSelectedVehicleStatuses(next);
    updateStatusesParam(next);
  };

  const handleVehicleDisplayedStatusSelect = (status) => {
    setSelectedVehicleDisplayedStatus([status]);
  }

  const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const calculateGreenPercentage = () => {
    const greenVehicles = filteredVehicles.filter(vehicle => {
      const statusColor = getStatusColor(vehicle);
      return statusColor === 'green'; // Bootstrap's green color
    });

    const percentage = filteredVehicles.length > 0 ? (greenVehicles.length / filteredVehicles.length) * 100 : 0;
    return Math.round(percentage); // Return the rounded percentage
  };

  const handleStartDateChange = (date) => setEtaStartDate(date);
  const handleEndDateChange = (date) => setEtaEndDate(date);

  const formatDateUTC = (timestamp) => {
    const date = normalizeToDate(timestamp);
    if (!date) return "";
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // ISO-like format without time
  };

  const getSalesRep = async (salesOrdNbr) => {
    const salesOrder = salesOrders.find(order => order.strSalesOrdNbr === salesOrdNbr);
    if (!salesOrder) return null; // Sales order not found
    const salesId = await queryData('salesIds', 'strSalesIdNbr', '==', salesOrder.strSalesId);
    if (!salesId || salesId.length === 0) return null; // Sales ID not found
    return salesId[0]; // Return the first matching sales ID
  };

  // Regular JavaScript function to get the current section from the URL path
  const getCurrentSection = () => {
    // Get the current path
    const pathname = window.location.pathname;

    // Extract the first section after the root, i.e., the first part of the URL path
    const section = `${pathname.split('/')[1] || ''}`;

    return section;
  };

  const globalSection = getCurrentSection();

  const getStatusColor = (vehicle) => {
    const upfitSummary = summarizeUpfitters(vehicle);
    // 5. Delivered to Customer (Green)
    if (vehicle.manualStatus === 'Ordered') {
      return 'white'; // Ordered status
    }
    if (vehicle.manualStatus === 'Scheduled') {
      return 'saddlebrown'; // Scheduled status
    }
    if (vehicle.manualStatus === 'Produced') {
      return 'saddlebrown'; // Produced status
    }
    if (vehicle.manualStatus === 'In Transit') {
      return 'saddlebrown'; // In Transit status
    }
    if (vehicle.manualStatus === 'On the Ground') {
      return 'orange'; // On the Ground status
    }
    if (vehicle.manualStatus === 'Customer Signed') {
      return 'yellow'; // Customer Signed status
    }
    if (vehicle.manualStatus === 'At Upfitter') {
      return 'blue'; // At Upfitter status
    }
    if (vehicle.manualStatus === 'Delivered') {
      return 'lightgreen'; // Delivered status
    }
    if (vehicle.manualStatus === 'Complete') {
      return 'green'; // Complete status
    }


    // 4. Process of Getting Vehicle Ready for Customer Delivery
    if (vehicle.dtCustSignedDate) {
      return 'blue'; // Customer Signed and Ownership Changed
    }

    if (upfitSummary.hasUpfitters) {
      if (upfitSummary.statusKey) {
        return getUpfitterColorByKey(upfitSummary.statusKey);
      }
      if (upfitSummary.label) {
        return 'blue';
      }
    } else if (vehicle.strUpfitterStatus) {
      if (vehicle.strUpfitterStatus === 'Complete') {
        return 'blue';
      }
      return 'blue';
    } else if (vehicle.dtUpfitterETA) {
      return 'blue';
    }

    // 3. Ready for Customer Signature
    if (vehicle.dtRecvDate) {
      return 'orange'; // On the Ground (Delivered at dealership or upfitter)
    }

    if (vehicle.dtPDI) {
      return 'orange'; // PDI (Pre-Delivery Inspection)
    }

    // 2. Vehicle In Process (Check for sub-statuses in reverse order)
    if (vehicle.dtManETA) {
      return 'saddlebrown'; // In Transit to Destination
    }

    if ((vehicle.strManStat >= 3800 && vehicle.strFactory === 'GM') ||
      (vehicle.strManStat === 'Produced' && vehicle.strFactory === 'Ford')) {
      return 'saddlebrown'; // Produced - 
    } //Might need to convert strManStat to number

    if (vehicle.dtProdDate) {
      return 'saddlebrown'; // Scheduled (GM TPW or Ford Build Date)
    }

    // 1. Vehicle Ordered (Default Status - No Color)
    return '#00000000'; // No color for default state
  };

  const getETAStr = (vehicle) => {
    const upfitSummary = summarizeUpfitters(vehicle);

    const formatDateFromTimestamp = (timestamp) => {
      const date = normalizeToDate(timestamp);
      if (!date) return '';
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // UTC month
      const day = String(date.getUTCDate()).padStart(2, '0');       // UTC day
      return `${month}/${day}/${year}`;
    };

    if (vehicle.manualETA) {
      const dateStr = formatDateFromTimestamp(vehicle.manualETA);
      if (vehicle.manualStatus === 'Complete') {
        return '';
      } else {
        return `(${dateStr})`;
      }
    }
    //(On Ground, Produced, Delivered, Complete)

    if (vehicle.manualStatus === "On the Ground" || vehicle.manualStatus === "Produced" || vehicle.manualStatus === "Delivered" || vehicle.manualStatus === "Complete" ) {
      return '';
    }

    if (vehicle.manualStatus) {
      return '';
    }

    // Upfitter ETA
    if (upfitSummary.hasUpfitters) {
      if (upfitSummary.statusKey === 'delayed' || upfitSummary.statusKey === 'at_upfitter') {
        const etaStr = formatDateFromTimestamp(upfitSummary.etaDate);
        if (etaStr) {
          return `U: ${etaStr}`;
        }
        const sentStr = formatDateFromTimestamp(upfitSummary.sentDate);
        if (sentStr) {
          return `S: ${sentStr}`;
        }
      }
    } else if (vehicle.dtUpfitterETA) {
      const dateStr = formatDateFromTimestamp(vehicle.dtUpfitterETA);
      if (dateStr) {
        return `U: ${dateStr}`;
      }
    }

    // Default to manufacturer ETA
    if (vehicle.dtRecvDate) {
      return ``;
    }

    // Manufacturer ETA
    if (vehicle.dtManETA) {
      const dateStr = formatDateFromTimestamp(vehicle.dtManETA);
      return `M: ${dateStr}`;
    }

    // Delivery ETA
    if (vehicle.dtProdDate) {
      const dateStr = formatDateFromTimestamp(vehicle.dtProdDate);
      return `P: ${dateStr}`;
    }

    return ''; // Default
  };

  const getETADate = (vehicle) => {
    const upfitSummary = summarizeUpfitters(vehicle);
    if (vehicle.manualStatus && vehicle.manualStatus !== "In Transit" && vehicle.manualStatus !== "Delivered") return null
    if (vehicle.manualETA) return vehicle.manualETA.toDate();
    if (upfitSummary.hasUpfitters && (upfitSummary.statusKey === 'delayed' || upfitSummary.statusKey === 'at_upfitter')) {
      const eta = normalizeToDate(upfitSummary.etaDate);
      if (eta) return eta;
    } else if (vehicle.dtUpfitterETA) {
      const eta = normalizeToDate(vehicle.dtUpfitterETA);
      if (eta) return eta;
    }
    if (vehicle.dtRecvDate) return null;
    if (vehicle.dtManETA) return vehicle.dtManETA.toDate();
    return null;
  }

  const getETADateSort = (vehicle) => {
    const upfitSummary = summarizeUpfitters(vehicle);
    if (vehicle.manualETA) return vehicle.manualETA.toDate();
    if (upfitSummary.hasUpfitters && (upfitSummary.statusKey === 'delayed' || upfitSummary.statusKey === 'at_upfitter')) {
      const eta = normalizeToDate(upfitSummary.etaDate);
      if (eta) return eta;
    } else if (vehicle.dtUpfitterETA) {
      return normalizeToDate(vehicle.dtUpfitterETA);
    }
    if (vehicle.dtRecvDate) return vehicle.dtRecvDate.toDate();
    if (vehicle.dtManETA) return vehicle.dtManETA.toDate();
    if (vehicle.dtProdDate) return vehicle.dtProdDate.toDate();
    return null;
  }

  const getCustomerName = (salesOrdNbr) => {
    const salesOrder = salesOrders.find(order => order.strSalesOrdNbr === salesOrdNbr);
    if (!salesOrder) return 'Unknown'; // Sales order not found
    const customer = customers.find(cust => cust.strCustNbr === salesOrder.strCustNbr);
    return customer ? customer.strCustName : 'Unknown'; // Return customer name or 'Unknown' if not found
  };

  const getSalesOrder = (salesOrdNbr) => {
    const salesOrder = salesOrders.find(order => order.strSalesOrdNbr === salesOrdNbr);
    if (!salesOrder) return null; // Sales order not found  
    return salesOrder; // Return sales order object
  };

  const getSalesOrdPONbr = (salesOrdNbr) => {
    const salesOrder = salesOrders.find(order => order.strSalesOrdNbr === salesOrdNbr);
    if (!salesOrder) return ''; // Sales order not found
    
    return salesOrder.strPONbr ? salesOrder.strPONbr : ''; // Return customer name or 'Unknown' if not found
  };

  const getContractNumber = (salesOrdNbr) => {
    const salesOrder = salesOrders.find(order => order.strSalesOrdNbr === salesOrdNbr);
    if (!salesOrder) return '';
    return salesOrder.strContractNbr || '';
  };

  const getCustomer = (salesOrdNbr) => {
    const salesOrder = salesOrders.find(order => order.strSalesOrdNbr === salesOrdNbr);
    if (!salesOrder) return null; // Sales order not found
    const customer = customers.find(cust => cust.strCustNbr === salesOrder.strCustNbr);
    return customer ? customer : null; // Return customer name or 'Unknown' if not found
  };

  const getUpfitter = (strUpfitterNbr) => {
    if (strUpfitterNbr === '') {
      return null
    }
    const upfitter = upfitters.find(upfit => upfit.strUpfitterNbr === strUpfitterNbr);
    return upfitter ? upfitter : null; // Return upfitter or 'Unknown' if not found
  };

  const getDOASReq = (salesOrdNbr) => {
    const salesOrder = salesOrders.find(order => order.strSalesOrdNbr === salesOrdNbr);
    if (!salesOrder) return false; // Sales order not found
    return salesOrder.bDOASReq ? true : false; 
  };

  const handleExportToXLSX = async () => {
    if (selectedVehicles.length === 0) {
      alert("Please select at least one vehicle to export.");
      return;
    }

    const section = getCurrentSection();
    const dataToExport = await Promise.all(
      selectedVehicles.map(async (vehicle) => {
        // Use `await` for asynchronous operations
        const customer = await getCustomer(vehicle.strSalesOrdNbr) || {}; // Default to an empty object if null/undefined
        const salesOrder = await getSalesOrder(vehicle.strSalesOrdNbr) || {};
        console.log('salesOrder payment:', salesOrder.strPayment);

        const upfitter = await getUpfitter(vehicle.strUpfitterNbr) || {};
        const upfitSummary = summarizeUpfitters(vehicle);
        const upfitterEntries = upfitSummary.entries;
        const aggregatedNumbers = upfitterEntries.map(entry => entry.upfitterNbr).filter(Boolean);
        const aggregatedNames = upfitterEntries.map(entry => entry.upfitter).filter(Boolean);
        const upfitterNumberField = aggregatedNumbers.length ? aggregatedNumbers.join(', ') : (vehicle.strUpfitterNbr || '');
        const upfitterNameField = aggregatedNames.length ? aggregatedNames.join(', ') : (upfitter.strUpfitterName || '');
        const upfitterStatusField = upfitSummary.hasUpfitters
          ? (upfitSummary.label || '')
          : (upfitSummary.fallbackLabel || getUpfitterStatus(vehicle.strUpfitterStatus) || '');
        const sentToUpfitterField = upfitSummary.hasUpfitters ? upfitSummary.sentDate : upfitSummary.fallbackSentDate;
        const upfitterEtaField = upfitSummary.hasUpfitters ? upfitSummary.etaDate : upfitSummary.fallbackEtaDate;
        const upfitterCompleteField = upfitSummary.hasUpfitters ? upfitSummary.completeDate : upfitSummary.fallbackCompleteDate;

        if (section === 'customer') {
          return {
            "Order #": vehicle.strOrdNbr ?? "",
            "Contract Number": getContractNumber(vehicle.strSalesOrdNbr) || "",
            "Vin": vehicle.strVin ?? "",
            "Year": vehicle.strYR ?? "",
            "Make": vehicle.strMake ?? "",
            "Model Name": modelCodes[
              `${vehicle.strFactory || ""} - ${vehicle.strModel || ""}`
            ] ||
              modelCodes[
              `${vehicle.strFactory || ""} - ${vehicle.strModel?.substring(0, 3) || ""}`
              ] ||
              vehicle.strModel || "",
            "Model Number": vehicle.strModel ?? "",
            "Color": colorCodes[`${vehicle.strFactory || ''} - ${vehicle.strColor || ''}`] ?? vehicle.strColor,
            "ETA Date": formatDateUTC(vehicle.manualETA) ?? "",
            "Display Status": getDisplayedStatus(vehicle) ?? "",
            "Paid Date": formatDateUTC(vehicle.dtPaidDate) ?? "",
            "Customer Payment": salesOrder.strPayment ?? "",
          };
        }

        if (section === 'salesorders') {
          return {
            "Sales Order Number": vehicle.strSalesOrdNbr ?? "",
            "Contract Number": getContractNumber(vehicle.strSalesOrdNbr) || "",
            "Contract Fee Indicator": getDOASReq(vehicle.strSalesOrdNbr) ?? "",
            "Customer Number": customer.strCustNbr ?? "",
            "Customer Name": customer.strCustName ?? "",
            "CDK Ford Number": customer.strCDKCustNbrFord ?? "",
            "CDK GM Number": customer.strCDKCustNbrGM ?? "",
            "Ford FIN": customer.strCustFordFIN ?? "",
            "GM FAN": customer.strCustGMFAN ?? "",
            "Addr 1": customer.strAddressLine1 ?? "",
            "Addr 2": customer.strAddressLine2 ?? "",
            "City ": customer.strCity ?? "",
            "State": customer.strState ?? "",
            "Zip": customer.strZip ?? "",
            "Order Number": vehicle.strOrdNbr ?? "",
            "Stock Number": vehicle.strStockNbr || vehicle.strVin?.slice(-8) || "",
            "Vin": vehicle.strVin ?? "",
            "Year": vehicle.strYR ?? "",
            "Make": vehicle.strMake ?? "",
            "Model Name": modelCodes[
              (vehicle.strFactory ? vehicle.strFactory : "") + " - " + (vehicle.strModel ? vehicle.strModel : "")
            ] ||
              modelCodes[
              (vehicle.strFactory ? vehicle.strFactory : "") + " - " + (vehicle.strModel ? vehicle.strModel.substring(0, 3) : "")
              ] ||
              (vehicle.strModel || ""),
            "Model Code": vehicle.strModel,
            "Color": colorCodes[`${vehicle.strFactory || ''} - ${vehicle.strColor || ''}`] ?? vehicle.strColor,
            "Engine Type": vehicle.strEngineType ?? "",
            "Keys": vehicle.curKeys ?? "",
            "MSRP": vehicle.curVehMSRP ?? "",
            "Price": vehicle.curVehSalePrice ?? "",
            "Cost": vehicle.curVehCOS ?? "",
            "Warranty Sale": vehicle.curWarrSale ?? "",
            "Warranty Cost": vehicle.curWarrCost ?? "",
            "Warranty Type": vehicle.strWarrType ?? "",
            "Tag & Title Fees": vehicle.curTTFees ?? "",
            "VQ2 - Hold Back": vehicle.curVQ2 ?? "",
            "Vehicle Incentive": vehicle.curVehIncent ?? "",
            "PO Line Number": vehicle.strPONbr ?? "",
            "PO Number": getSalesOrdPONbr(vehicle.strSalesOrdNbr) ?? "",
            "Contract Fee": vehicle.curDoas ?? "",
            "Accessories": vehicle.currAccess ?? "",
            "Upfit Cost": vehicle.curUpfitCost ?? "",
            "Transport Cost": vehicle.curTransCost ?? "",
            "Taxes": vehicle.curTaxes ?? "",
            "Rebate": vehicle.curRebate ?? "",
            "Manufacture ETA Date": formatDateUTC(vehicle.dtManETA) ?? "",
            "Production Date": formatDateUTC(vehicle.dtProdDate) ?? "",
            "Manufacture Status": vehicle.strManStat ?? "",
            "Received Date": formatDateUTC(vehicle.dtRecvDate) ?? "",
            "PDI Date": formatDateUTC(vehicle.dtPDI) ?? "",
            "Sales Date": formatDateUTC(vehicle.dtSaleDate) ?? "",
            "Upfitter Number": upfitterNumberField ?? "",
            "Upfitter Name": upfitterNameField ?? "",
            "Sent To Upfitter Date": formatDateUTC(sentToUpfitterField) ?? "",
            "Upfitter ETA Date": formatDateUTC(upfitterEtaField) ?? "",
            "Upfitter Complete Date": formatDateUTC(upfitterCompleteField) ?? "",
            "Upfitter Status": upfitterStatusField ?? "",
            "Manual Status": vehicle.manualStatus ?? "",
            "Manual ETA Date": formatDateUTC(vehicle.manualETA) ?? "",
            "Billed CDK Indicator": vehicle.bBillCDK ?? false,
            "Recall Indicator": vehicle.bRecall ?? false,
            "Displayed Status": getDisplayedStatus(vehicle) ?? "",
            "Paid Date": formatDateUTC(vehicle.dtPaidDate) ?? "",
            "Customer Payment": salesOrder.strPayment ?? "",
          };
        }

        if (section === 'upfitter') {
          return {
            "Order #": vehicle.strOrdNbr ?? "",
            "Contract Number": getContractNumber(vehicle.strSalesOrdNbr) || "",
            "Vin": vehicle.strVin ?? "",
            "Year": vehicle.strYR ?? "",
            "Make": vehicle.strMake ?? "",
            "Model Name": modelCodes[
              `${vehicle.strFactory || ""} - ${vehicle.strModel || ""}`
            ] ||
              modelCodes[
              `${vehicle.strFactory || ""} - ${vehicle.strModel?.substring(0, 3) || ""}`
              ] ||
              vehicle.strModel || "",
            "Model Number": vehicle.strModel ?? "",
            "Color": colorCodes[`${vehicle.strFactory || ''} - ${vehicle.strColor || ''}`] ?? vehicle.strColor,
            "ETA Date": formatDateUTC(vehicle.manualETA) ?? "",
            "Display Status": getDisplayedStatus(vehicle) ?? "",
            "Paid Date": formatDateUTC(vehicle.dtPaidDate) ?? "",
            "Customer Payment": salesOrder.strPayment ?? "",
          }
        }
        return {
          "Sales Order Number": vehicle.strSalesOrdNbr ?? "",
          "Contract Number": getContractNumber(vehicle.strSalesOrdNbr) || "",
          "Vehicle Ordered Date": formatDateUTC(vehicle.createdDate) ?? "",
          "Customer Number": customer.strCustNbr ?? "",
          "Customer Name": customer.strCustName ?? "",
          "Order Number": vehicle.strOrdNbr ?? "",
          "Stock Number": vehicle.strStockNbr || vehicle.strVin?.slice(-8) || "",
          "Vin": vehicle.strVin ?? "",
          "Year": vehicle.strYR ?? "",
          "Make": vehicle.strMake ?? "",
          "Model Name": modelCodes[
            (vehicle.strFactory ? vehicle.strFactory : "") + " - " + (vehicle.strModel ? vehicle.strModel : "")
          ] ||
            modelCodes[
            (vehicle.strFactory ? vehicle.strFactory : "") + " - " + (vehicle.strModel ? vehicle.strModel.substring(0, 3) : "")
            ] ||
            (vehicle.strModel || ""),
          "Model Code": vehicle.strModel,
          "Color": colorCodes[`${vehicle.strFactory || ''} - ${vehicle.strColor || ''}`] ?? vehicle.strColor,
          "Engine Type": vehicle.strEngineType ?? "",
          "Keys": vehicle.curKeys ?? "",
          "MSRP": vehicle.curVehMSRP ?? "",
          "Price": vehicle.curVehSalePrice ?? "",
          "Cost": vehicle.curVehCOS ?? "",
          "Warranty Sale": vehicle.curWarrSale ?? "",
          "Warranty Cost": vehicle.curWarrCost ?? "",
          "Warranty Type": vehicle.strWarrType ?? "",
          "Tag & Title Fees": vehicle.curTTFees ?? "",
          "VQ2 - Hold Back": vehicle.curVQ2 ?? "",
          "Vehicle Incentive": vehicle.curVehIncent ?? "",
          "PO Line Number": vehicle.strPONbr ?? "",
          "PO Number": getSalesOrdPONbr(vehicle.strSalesOrdNbr) ?? "",
          "Contract Fee": vehicle.curDoas ?? "",
          "Accessories": vehicle.currAccess ?? "",
          "Upfit Cost": vehicle.curUpfitCost ?? "",
          "Transport Cost": vehicle.curTransCost ?? "",
          "Taxes": vehicle.curTaxes ?? "",
          "Rebate": vehicle.curRebate ?? "",
          "Manufacture ETA Date": formatDateUTC(vehicle.dtManETA) ?? "",
          "Production Date": formatDateUTC(vehicle.dtProdDate) ?? "",
          "Manufacture Status": vehicle.strManStat ?? "",
          "Received Date": formatDateUTC(vehicle.dtRecvDate) ?? "",
          "PDI Date": formatDateUTC(vehicle.dtPDI) ?? "",
          "Sales Date": formatDateUTC(vehicle.dtSaleDate) ?? "",
          "Upfitter Number": upfitterNumberField ?? "",
          "Upfitter Name": upfitterNameField ?? "",
          "Sent To Upfitter Date": formatDateUTC(sentToUpfitterField) ?? "",
          "Upfitter ETA Date": formatDateUTC(upfitterEtaField) ?? "",
          "Upfitter Complete Date": formatDateUTC(upfitterCompleteField) ?? "",
          "Upfitter Status": upfitterStatusField ?? "",
          "Manual Status": vehicle.manualStatus ?? "",
          "Manual ETA Date": formatDateUTC(vehicle.manualETA) ?? "",
          "Billed CDK Indicator": vehicle.bBillCDK ?? false,
          "Recall Indicator": vehicle.bRecall ?? false,
          "Last Updated": formatDateUTC(vehicle.lastUpdated) ?? "",
          "Displayed Status": getDisplayedStatus(vehicle) ?? "",
          "Paid Date": formatDateUTC(vehicle.dtPaidDate) ?? "",
          "Delivery Date": formatDateUTC(vehicle.dtDelivDate) ?? "",
          "Customer Payment": salesOrder.strPayment ?? "",
        };
      })
    );


    // Create a worksheet
    const worksheet = utils.json_to_sheet(dataToExport);

    // Create a workbook and append the worksheet
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Vehicles");

    // Export the workbook
    const currentDate = new Date().toISOString().slice(0, 10);
    let exportName = "";
    if (section === 'salesorders') {
      exportName = "Bill_Out_"
    } 
    writeFile(workbook, `Selected_Vehicles_${exportName}${currentDate}.xlsx`);
  };

  
  const handleSortClick = (column) => {
    let direction = 'asc';

    // Toggle direction if the same column is clicked
    if (sortColumn === column && sortDirection === 'asc') {
      direction = 'desc';
    } else if (sortColumn === column && sortDirection === 'desc') {
      direction = 'asc';
    }

    setSortColumn(column);
    setSortDirection(direction);

    const sortedVehicles = [...filteredVehicles].sort((a, b) => {
      let fieldA, fieldB;

      if (column === 'strSalesOrdNbr') {
        // Custom sorting for strSalesOrdNbr
        const [dateA, seqA] = a.strSalesOrdNbr.split('-').map((part, index) => index === 1 ? parseInt(part, 10) : part);
        const [dateB, seqB] = b.strSalesOrdNbr.split('-').map((part, index) => index === 1 ? parseInt(part, 10) : part);

        if (dateA !== dateB) {
          return direction === 'asc' ? dateA.localeCompare(dateB) : dateB.localeCompare(dateA);
        }
        return direction === 'asc' ? seqA - seqB : seqB - seqA;
      }

      if (column === 'eta') {
        // Sort by ETA date
        fieldA = getETADateSort(a) || new Date(0);
        fieldB = getETADateSort(b) || new Date(0);
      } else if (column === 'customerName') {
        // Sort by customer name
        fieldA = getCustomerName(a.strSalesOrdNbr).toLowerCase();
        fieldB = getCustomerName(b.strSalesOrdNbr).toLowerCase();
      } else if (column === 'status') {
        // Sort by displayed status
        fieldA = getDisplayedStatus(a).toLowerCase();
        fieldB = getDisplayedStatus(b).toLowerCase();
      } else if (column === 'model') {
        // Sort by model name
        fieldA = (
          modelCodes[`${a.strFactory || ''} - ${a.strModel || ''}`] ||
          modelCodes[`${a.strFactory || ''} - ${a.strModel?.substring(0, 3) || ''}`] ||
          a.strModel || ''
        ).toLowerCase();
        fieldB = (
          modelCodes[`${b.strFactory || ''} - ${b.strModel || ''}`] ||
          modelCodes[`${b.strFactory || ''} - ${b.strModel?.substring(0, 3) || ''}`] ||
          b.strModel || ''
        ).toLowerCase();
      } else if (column === 'strStockNbr') {
        // Sort by stock number (last 8 digits of VIN if stock number is unavailable)
        fieldA = a['strVin'] ? a['strVin'].slice(-8).toLowerCase() : '';
        fieldB = b['strVin'] ? b['strVin'].slice(-8).toLowerCase() : '';
      } else {
        // Default sorting
        fieldA = a[column]?.toString().toLowerCase() || '';
        fieldB = b[column]?.toString().toLowerCase() || '';
      }

      if (direction === 'asc') {
        return fieldA < fieldB ? -1 : fieldA > fieldB ? 1 : 0;
      } else {
        return fieldA > fieldB ? -1 : fieldA < fieldB ? 1 : 0;
      }
    });

    setFilteredVehicles(sortedVehicles);
  };

  const getDisplayedStatus = (vehicle) => {
    const upfitSummary = summarizeUpfitters(vehicle);
    // 5. Delivered to Customer (Final State)
    if (vehicle.manualStatus === 'Scheduled') {
      return 'Scheduled';
    }
    if (vehicle.manualStatus === 'Produced') {
      return 'Produced';
    }
    if (vehicle.manualStatus === 'In Transit') {
      return 'In Transit';
    }
    if (vehicle.manualStatus === 'On the Ground') {
      return 'On the Ground';
    }
    if (vehicle.manualStatus === 'Customer Signed') {
      return 'Customer Signed';
    }
    if (vehicle.manualStatus === 'At Upfitter') {
      if (upfitSummary.hasUpfitters && upfitSummary.label) {
        return upfitSummary.label;
      }
      if (vehicle.strUpfitterStatus && vehicle.strUpfitterStatus !== 'Complete') {
        return getUpfitterStatus(vehicle.strUpfitterStatus);
      }
      return 'At Upfitter';
    }
    if (vehicle.manualStatus === 'Delivered') {
      return 'Delivered';
    }
    if (vehicle.manualStatus === 'Complete') {
      return 'Complete';
    }


    // 4. Process of Getting Vehicle Ready for Customer Delivery
    if (vehicle.dtCustSignedDate) {
      return 'Customer Signed and Ownership Changed';
    }

    if (upfitSummary.hasUpfitters) {
      switch (upfitSummary.statusKey) {
        case 'complete':
          return 'Complete';
        case 'delayed':
          return upfitSummary.label || 'Delayed at Upfitter';
        case 'at_upfitter':
          return upfitSummary.label || 'Vehicle at Upfitter';
        case 'ready':
          return upfitSummary.label || 'Ready for Upfitter';
        case 'returned':
          return upfitSummary.label || 'Vehicle Returned from Upfitter';
        default:
          if (upfitSummary.label) {
            return upfitSummary.label;
          }
      }
    } else if (vehicle.strUpfitterStatus && vehicle.strUpfitterStatus !== 'Complete') {
      return upfitSummary.fallbackLabel || getUpfitterStatus(vehicle.strUpfitterStatus);
    }

    // 3. Ready for Customer Signature
    if (vehicle.dtRecvDate) {
      return 'On the Ground';
    }

    if (!upfitSummary.hasUpfitters && vehicle.strUpfitterStatus && vehicle.strUpfitterStatus === 'Complete') {
      return 'Delivered to Customer';
    }

    // 2. Vehicle In Process
    if (vehicle.strManStat || vehicle.dtProdDate || vehicle.dtManETA) {
      // a. In Transit to Destination
      if (vehicle.dtManETA) {
        return 'In Transit';
      }

      // b. Produced (GM status >= 3800 or Ford status "Produced")
      if (vehicle.strManStat && (parseInt(vehicle.strManStat) >= 3800 || vehicle.strManStat === 'Produced')) {
        return 'Produced';
      }

      // c. Scheduled (TPW or Build Date is set)
      if (vehicle.dtProdDate) {
        return 'Scheduled';
      }
    }

    // 1. Vehicle Ordered (Default Status)
    if (!vehicle.strManStat && !vehicle.dtProdDate && !vehicle.dtManETA) {
      return 'Vehicle Ordered';
    }

    // Default to 'Vehicle Ordered' if no other statuses are applicable
    return 'Vehicle Ordered';
  };


  function getUpfitterStatus(strUpfitterStatus) {
    try {
      const upfitterStatusCode = upfitterStatusCodes.find(code => code.strManStat === strUpfitterStatus?.toString());
      return upfitterStatusCode ? upfitterStatusCode.strFactStatus : null;
    } catch (error) {
      return null;
    }
  }

  /*
  const handleCreateTeamsFolders = async () => {
    setShowTeamsModal(true);
    setTeamsLoading(true);
    setTeamsProgress(0);

    try {
      await createTeamsFoldersForVehicles(selectedVehicles, getDocument, queryData, modelCodes);
      setTeamsProgress(100);  // Assuming successful completion
    } catch (error) {
      console.error('Error creating Teams folders:', error);
    } finally {
      setTeamsLoading(false);
      setShowTeamsModal(false);
    }
  };
  */

  useEffect(() => {
    const fetchColorCodes = async () => {
      const colorCodesData = await getData('colorCodes');
      const colorCodesMap = colorCodesData.reduce((map, obj) => {
        map[obj.strFactory + " - " + obj.strColor] = obj.strColorName;
        return map;
      }, {});
      setColorCodes(colorCodesMap);
    };

    fetchColorCodes();
  }, [getData]);

  useEffect(() => {
    const fetchModelCodes = async () => {
      const modelCodesData = await getData('modelCodes');
      const modelCodesMap = modelCodesData.reduce((map, obj) => {
        map[obj.strFactory + " - " + obj.strModel] = obj.strModelName;
        return map;
      }, {});
      setModelCodes(modelCodesMap);
    };

    fetchModelCodes();
  }, [getData]);

  useEffect(() => {
    const filterVehicles = () => {
      const filtered = vehicles.filter(vehicle => {

        // Get the ETA date (convert Firestore Timestamp to JavaScript Date)
        const etaDate = getETADate(vehicle);

        //const isDisplayedStatus = (!vehicleDisplayedStatus || vehicleDisplayedStatus && vehicleDisplayedStatus == selectedVehicleDisplayedStatus)
        
        // Check if the vehicle's ETA falls within the selected range
        const isWithinDateRange =
          (!etaStartDate || (etaDate && etaDate >= etaStartDate)) &&
          (!etaEndDate || (etaDate && etaDate <= etaEndDate));

        // Additional filtering logic (search query, status, etc.)
        const terms = deferredSearchQuery
          .split(',')
          .map(term => term.trim().toLowerCase())
          .filter(Boolean);

        const matchesTerm = (term) => {
          if (!term) return true;
          const modelFull = modelCodes[`${vehicle.strFactory ? vehicle.strFactory : ''} - ${vehicle.strModel ? vehicle.strModel : ''}`]?.toLowerCase();
          const modelShortFactory = modelCodes[`${vehicle.strFactory ? vehicle.strFactory : ''} - ${vehicle.strModel ? vehicle.strModel.substring(0, 3) : ''}`]?.toLowerCase();
          const modelShortMake = modelCodes[`${vehicle.strMake ? capitalizeFirstLetter(vehicle.strMake) : ''} - ${vehicle.strModel ? vehicle.strModel.substring(0, 3) : ''}`]?.toLowerCase();
          const modelShortGM = modelCodes[`GM - ${vehicle.strModel ? vehicle.strModel.substring(0, 3) : ''}`]?.toLowerCase();
          const normalizedMake = (vehicle.strMake || '').trim().toLowerCase();
          const normalizedYear = (vehicle.strYR != null ? String(vehicle.strYR) : '').trim().toLowerCase();
          const normalizedModel = (vehicle.strModel || '').trim().toLowerCase();
          const normalizedCustomer = (getCustomerName(vehicle.strSalesOrdNbr) || '').trim().toLowerCase();

          return (
            (vehicle.strOrdNbr || '').toLowerCase().includes(term) ||
            String(vehicle.nDAN ?? '').toLowerCase().includes(term) ||
            (vehicle.strVin || '').toLowerCase().includes(term) ||
            normalizedMake.includes(term) ||
            normalizedYear.includes(term) ||
            normalizedModel.includes(term) ||
            (allVehicles && (vehicle.strSalesOrdNbr || '').toLowerCase().includes(term)) ||
            normalizedCustomer.includes(term) ||
            (modelFull && modelFull.includes(term)) ||
            (modelShortFactory && modelShortFactory.includes(term)) ||
            (modelShortMake && modelShortMake.includes(term)) ||
            (modelShortGM && modelShortGM.includes(term))
          );
        };

        let matchesQuery = true;
        if (terms.length > 0) {
          if (deferredSearchOperator === 'and') {
            matchesQuery = terms.every(matchesTerm);
          } else {
            matchesQuery = terms.some(matchesTerm);
          }
        } else {
          matchesQuery = true;
        }

        let paidOnly = true;
        if (paidSelected) {
          paidOnly = (vehicle.dtPaidDate ? true : false)
        } 

        let isDisplayedStatus
        if (selectedVehicleDisplayedStatus.includes('All')) {
          isDisplayedStatus = true
        } else {
          isDisplayedStatus = selectedVehicleDisplayedStatus.includes(getDisplayedStatus(vehicle))
            ? true
            : false;
        }

        // Filter based on the selected statuses ("Active" shows all except "Complete")
        let isStatusIncluded
        if (selectedVehicleStatuses.includes('All')) {
          isStatusIncluded = true
        } else {
          isStatusIncluded = selectedVehicleStatuses.includes('Complete')
            ? vehicle.manualStatus === 'Complete'
            : vehicle.manualStatus !== 'Complete';
        }

        return isWithinDateRange && isDisplayedStatus && matchesQuery && isStatusIncluded && paidOnly
      });

      setFilteredVehicles(filtered);
      setTotalRows(filtered.length);
      setCurrentPage(1); // Reset to the first page when filtering changes
    };

    filterVehicles();
  }, [vehicles, etaStartDate, etaEndDate, deferredSearchQuery, deferredSearchOperator, allVehicles, selectedVehicleStatuses, paidSelected, selectedVehicleDisplayedStatus]);


  const handleVehicleRowClick = (vehicle) => {
    if (selectedVehicle && selectedVehicle.strOrdNbr === vehicle.strOrdNbr) {
      setSelectedVehicle(null); // Deselect if the same vehicle is clicked again
    } else {
      setSelectedVehicle(vehicle);
    }
  };

  const updateSearchParam = (value) => {
    if (!syncSearchWithUrl) return;
    const params = new URLSearchParams(location.search);
    const currentValue = params.get('search') || '';
    if (currentValue === value) return;

    if (value) {
      params.set('search', value);
    } else {
      params.delete('search');
    }
    const searchString = params.toString();
    navigate(
      {
        pathname: location.pathname,
        search: searchString ? `?${searchString}` : '',
      },
      { replace: true }
    );
  };

  const updateSearchOperatorParam = (value) => {
    if (!syncSearchWithUrl) return;
    const params = new URLSearchParams(location.search);
    const normalized = value === 'and' ? 'and' : 'or';
    const current = (params.get('op') || 'or').toLowerCase();
    if (current === normalized) return;
    if (normalized === 'or') {
      params.delete('op');
    } else {
      params.set('op', normalized);
    }
    const searchString = params.toString();
    navigate(
      {
        pathname: location.pathname,
        search: searchString ? `?${searchString}` : '',
      },
      { replace: true }
    );
  };

  const updateStatusesParam = (statuses) => {
    if (!syncSearchWithUrl) return;
    const params = new URLSearchParams(location.search);
    const defaults = getDefaultStatuses();
    if (!statuses || statuses.length === 0 || arraysEqual(statuses, defaults)) {
      params.delete('status');
    } else {
      params.set('status', statuses.join(','));
    }
    const searchString = params.toString();
    navigate(
      {
        pathname: location.pathname,
        search: searchString ? `?${searchString}` : '',
      },
      { replace: true }
    );
  };

  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    updateSearchParam(value);
  };

  const handleSearchOperatorChange = (op) => {
    if (!op) return;
    const normalized = op === 'and' ? 'and' : 'or';
    setSearchOperator(normalized);
    updateSearchOperatorParam(normalized);
  };

  const handleVehicleAdded = async () => {
    const vehicleData = selectedOrder
      ? await queryData('vehicles', 'strSalesOrdNbr', '==', selectedOrder.strSalesOrdNbr)
      : await getData('vehicles');

    setVehicles(vehicleData);
    setShowBulkEditModal(false);
    setShowAddModal(false); // Close the modal after adding the vehicle
  };

  const formatCurrency = (value) => {
    if (value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(value);
    }
    return '';
  };


  const handleVehicleUpdated = async (updatedVehicle) => {
    if (!updatedVehicle || !updatedVehicle.id) {
      console.error('Updated vehicle or vehicle ID is missing');
      return;
    }
    await updateData('vehicles', updatedVehicle.id, updatedVehicle);
    const updatedVehicles = vehicles.map(v => (v.id === updatedVehicle.id ? updatedVehicle : v));
    setVehicles(updatedVehicles);
    setShowBulkEditModal(false); // Close the modal after updating the vehicle
  };

  const handleBulkEditClick = () => {
    if (selectedVehicles.length === 0) {
      return;
    }
    setVehicleToEdit(selectedVehicles);
    setShowBulkEditModal(true);
  };

  const handleCSVFile = async (file) => {
    setLoading(true);
    setProgress(0);
    setCurrentImportSheet(file?.name || 'VINView CSV');

    const parseCsv = () => new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: resolve,
        error: reject,
      });
    });

    try {
      const results = await parseCsv();
      const rows = Array.isArray(results?.data) ? results.data : [];
      const totalRows = rows.length || 1;

      const vehiclesData = await getData('vehicles');
      const vehicleLookups = buildVehicleLookups(vehiclesData);
      const pendingUpdates = [];
      const BATCH_WRITE_LIMIT = 400;

      const commitPending = async (force = false) => {
        if (!pendingUpdates.length) return;
        if (!force && pendingUpdates.length < BATCH_WRITE_LIMIT) return;

        const batch = writeBatch(db);
        pendingUpdates.forEach(({ id, data }) => {
          const ref = doc(db, 'vehicles', id);
          batch.update(ref, { ...data, lastUpdated: serverTimestamp() });
        });
        await batch.commit();
        pendingUpdates.splice(0, pendingUpdates.length);
      };

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i] || {};
        const vin = (row['VIN'] || '').toString().trim();
        const vinStatus = (row['VIN Status'] || '').toString().trim();
        const lastMilestone = (row['Last Milestone'] || '').toString().trim();

        setCurrentVehicleInfo({
          strOrdNbr: row['Order'] || row['Order #'] || '',
          strVin: vin,
          strYR: row['Model Year'] || row['Year'] || '',
          strMake: row['Make'] || row['Division'] || row['Brand'] || '',
          strModel: row['Model'] || row['Body'] || '',
        });

        if (!vin) {
          setProgress(Math.round(((i + 1) / totalRows) * 100));
          continue;
        }

        const existing = vehicleLookups.byVin.get(normalizeKey(vin));
        if (!existing) {
          setProgress(Math.round(((i + 1) / totalRows) * 100));
          continue;
        }

        const etaSource = vinStatus === 'Delivered'
          ? row['Last Milestone Local Date']
          : row['End Intelligent ETA Local Date'];
        const etaDate = parseValidDate(etaSource);

        const updatePayload = {};
        if (etaDate !== null) {
          updatePayload.dtManETA = etaDate === 'TBD' ? null : Timestamp.fromDate(etaDate);
        }
        if (vinStatus) {
          updatePayload.strVinStatus = vinStatus;
        }
        if (lastMilestone) {
          updatePayload.strManStat = lastMilestone;
        }

        if (Object.keys(updatePayload).length > 0) {
          setCurrentVehicleStatus('Updated');
          Object.assign(existing, updatePayload);
          pendingUpdates.push({ id: existing.id, data: updatePayload });
          if (pendingUpdates.length >= BATCH_WRITE_LIMIT) {
            await commitPending();
          }
        }

        setProgress(Math.round(((i + 1) / totalRows) * 100));
      }

      await commitPending(true);
      setReload(reload + 1);
    } catch (error) {
      console.error('Error parsing CSV:', error);
    } finally {
      setLoading(false);
      setCurrentImportSheet('');
      setCurrentVehicleInfo(null);
      setCurrentVehicleStatus('');
    }
  };

  // Helper function to validate and parse dates in MM/DD/YYYY format
  const parseValidDate = (dateString) => {
    if (!dateString || typeof dateString !== 'string') return null;

    // Check for "TBD - On Hold" and return it directly if found
    if (dateString === "TBD - On Hold" || dateString === "TBD") {
      return "TBD";
    }

    // Use regular expression to match MM/DD/YYYY format
    const regex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    if (!regex.test(dateString)) {
      return null; // Return null for invalid date formats
    }

    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date; // Return null if the date is invalid
  };


  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const fileName = file.name.toLowerCase(); // Convert the file name to lowercase

    if (fileName.includes('vinview')) {
      await handleCSVFile(file); // Handle CSV file for VINView
    } else if (fileName.includes('ford') || fileName.includes('gm')) {
      const data = await file.arrayBuffer();
      const workbook = read(data, { type: 'array' });
      if (fileName.includes('ford')) {
        await handleFordFile(workbook);
      } else {
        await handleGMFile(workbook);
      }
    }
  };


  const getCircleColor = (percentage) => {
    if (percentage >= 75) {
      return "green"; // High percentage = green
    } else if (percentage >= 45) {
      return "yellow"; // Medium percentage = yellow
    } else if (percentage >= 10) {
      return "orange"; // Low percentage = orange
    } else {
      return "white"; // Very low percentage = red
    }
  };


  const handleGMFile = async (workbook) => {
    const sheetNames = workbook.SheetNames;
    let totalVehicles = 0;

    // Calculate total vehicles for progress tracking
    sheetNames.forEach(sheetName => {
      const worksheet = workbook.Sheets[sheetName];
      const json = utils.sheet_to_json(worksheet); // No longer skipping any rows
      totalVehicles += json.length;
    });

    setLoading(true);

    try {
      for (const sheetName of sheetNames) {
        let processedVehicles = 0;
        setCurrentImportSheet(sheetName);
        const worksheet = workbook.Sheets[sheetName];
        const json = utils.sheet_to_json(worksheet); // No longer skipping any rows
        const mappedVehicles = json.map(vehicle => ({ ...mapGMFields(vehicle) }));

        processedVehicles += mappedVehicles.length;
        setProgress(Math.round((processedVehicles / totalVehicles) * 100));
        await updateVehicles(mappedVehicles, setProgress, async () => {
          const vehicleData = await getData('vehicles');
          setVehicles(vehicleData);
          setFilteredVehicles(vehicleData); // Update filtered vehicles as well
        });
      }
    } finally {
      setLoading(false);
      setCurrentImportSheet('');
    }
  };



  const handleFordFile = async (workbook) => {
    const sheetNames = workbook.SheetNames;
    let totalVehicles = 0;

    // Calculate total vehicles for progress tracking
    sheetNames.forEach(sheetName => {
      const worksheet = workbook.Sheets[sheetName];
      const json = utils.sheet_to_json(worksheet, { range: 2 }); // Skip the first two rows
      totalVehicles += json.length;
    });

    setLoading(true);

    try {
      for (const sheetName of sheetNames) {
        let processedVehicles = 0;
        setCurrentImportSheet(sheetName);
        const worksheet = workbook.Sheets[sheetName];
        const json = utils.sheet_to_json(worksheet, { range: 2 }); // Skip the first two rows
        const mappedVehicles = json.map(vehicle => ({ ...mapFordFields(vehicle) }));
        processedVehicles += mappedVehicles.length;
        setProgress(Math.round((processedVehicles / totalVehicles) * 100));

        await updateVehicles(mappedVehicles, setProgress, async () => {
          const vehicleData = await getData('vehicles');
          setVehicles(vehicleData);
          setFilteredVehicles(vehicleData); // Update filtered vehicles as well
        });
      }
    } finally {
      setLoading(false);
      setCurrentImportSheet('');
    }
  };

  const updateVehicles = async (vehicles, setProgress, callback) => {
    try {
      if (!Array.isArray(vehicles) || vehicles.length === 0) {
        if (callback) {
          await callback();
        }
        return;
      }

      const vehiclesData = await getData('vehicles');
      const allSalesOrders = await getData('salesOrders');
      const activeOrders = allSalesOrders.filter(order => (order.strSalesOrdStatus || '').trim().toLowerCase() === 'active');
      const ordersForLookup = activeOrders.length ? activeOrders : allSalesOrders;

      const vehicleLookups = buildVehicleLookups(vehiclesData);
      const orderLookups = buildActiveOrderLookups(ordersForLookup);

      const pendingUpdates = [];
      const pendingCreates = [];
      const pendingCreateMap = new Map();
      const BATCH_WRITE_LIMIT = 400;

      const commitPending = async (force = false) => {
        const pendingTotal = pendingUpdates.length + pendingCreates.length;
        const shouldCommit = force || pendingTotal >= BATCH_WRITE_LIMIT;
        if (!shouldCommit || pendingTotal === 0) {
          return;
        }

        const batch = writeBatch(db);

        pendingUpdates.forEach(({ id, data }) => {
          const ref = doc(db, 'vehicles', id);
          batch.update(ref, { ...data, lastUpdated: serverTimestamp() });
        });

        pendingCreates.forEach(({ ref, data }) => {
          batch.set(ref, { ...data, lastUpdated: serverTimestamp() });
        });

        try {
          await batch.commit();
        } catch (err) {
          console.error('Batch commit failed', err);
          throw err;
        }

        pendingUpdates.splice(0, pendingUpdates.length);
        pendingCreates.splice(0, pendingCreates.length);
      };

      for (let i = 0; i < vehicles.length; i++) {
        const vehicle = vehicles[i];

        setCurrentVehicleInfo({
          strOrdNbr: vehicle.strOrdNbr || '',
          strVin: vehicle.strVin || '',
          strYR: vehicle.strYR || '',
          strMake: vehicle.strMake || vehicle.strFactory || '',
          strModel: vehicle.strModel || '',
        });

        const result = findVehicle(vehicle, orderLookups, vehicleLookups);     

        if (result.found) {
        const existing = result.vehicle;
        const pendingCreateData = existing?.id ? pendingCreateMap.get(existing.id) : null;
        const updateDataFields = {};

          Object.keys(vehicle).forEach((field) => {
            const value = vehicle[field];
            if (value === '' || value === null || value === undefined) {
              return;
            }
            if (existing[field] !== value) {
              updateDataFields[field] = value;
            }
          });

        if (Object.keys(updateDataFields).length > 0) {
          const previousVin = normalizeKey(existing.strVin);
          const previousOrder = normalizeKey(existing.strOrdNbr);
          const previousYear = normalizeKey(existing.strYR);

          Object.assign(existing, updateDataFields);

          if (pendingCreateData) {
            // Merge into the yet-to-be-created doc instead of issuing an update
            Object.assign(pendingCreateData, updateDataFields);
            setCurrentVehicleStatus('New');
          } else {
            setCurrentVehicleStatus('Updated');
            pendingUpdates.push({ id: existing.id, data: updateDataFields });
          }

          const nextVin = normalizeKey(existing.strVin);
          if (nextVin !== previousVin) {
            if (previousVin) {
              vehicleLookups.byVin.delete(previousVin);
            }
            if (nextVin) {
              vehicleLookups.byVin.set(nextVin, existing);
            }
          }

          const nextOrder = normalizeKey(existing.strOrdNbr);
          const nextYear = normalizeKey(existing.strYR);
          if (previousOrder !== nextOrder || previousYear !== nextYear) {
            if (previousOrder) {
              const list = vehicleLookups.byOrder.get(previousOrder) || [];
              const filtered = list.filter(v => v.id !== existing.id);
              if (filtered.length) {
                vehicleLookups.byOrder.set(previousOrder, filtered);
              } else {
                vehicleLookups.byOrder.delete(previousOrder);
              }
            }

            if (nextOrder) {
              const list = vehicleLookups.byOrder.get(nextOrder) || [];
              if (!list.find(v => v.id === existing.id)) {
                list.push(existing);
              }
              vehicleLookups.byOrder.set(nextOrder, list);
            }
          }
        }
      } else {
          const resolvedSalesOrdNbr = result.strSalesOrdNbr || (vehicle.strSalesOrdNbr ? String(vehicle.strSalesOrdNbr) : '');
          if (!resolvedSalesOrdNbr) {
            console.warn('Skipping vehicle create: no sales order match for vehicle', vehicle);
            continue;
          }
          setCurrentVehicleStatus('New');
          const ref = doc(collection(db, 'vehicles'));
          const newVehicleData = sanitizeForFirestore({
            ...vehicle,
            strSalesOrdNbr: resolvedSalesOrdNbr,
            createdDate: Timestamp.now(),
          });

          pendingCreates.push({ ref, data: newVehicleData });
          pendingCreateMap.set(ref.id, newVehicleData);

          const storedVehicle = { id: ref.id, ...newVehicleData };
          const vinKey = normalizeKey(storedVehicle.strVin);
          if (vinKey && !vehicleLookups.byVin.has(vinKey)) {
            vehicleLookups.byVin.set(vinKey, storedVehicle);
          }

          const orderKey = normalizeKey(storedVehicle.strOrdNbr);
          if (orderKey) {
            const list = vehicleLookups.byOrder.get(orderKey) || [];
            list.push(storedVehicle);
            vehicleLookups.byOrder.set(orderKey, list);
          }
        }

        setProgress(Math.round(((i + 1) / vehicles.length) * 100));
        if ((pendingUpdates.length + pendingCreates.length) >= BATCH_WRITE_LIMIT) {
          await commitPending();
        }
      }

      await commitPending(true);

      if (callback) {
        await callback();
      }

      setCurrentVehicleInfo(null);
      setCurrentVehicleStatus('');
    } catch (err) {
      console.error('Error updating vehicles', err);
      alert(`Vehicle import failed: ${err?.message || err}`);
      throw err;
    }
  };



  const normalizePrice = (price) => {
    if (!price) return 0;

    // Remove any dollar signs ($) and commas (,)
    const normalizedPrice = price.replace(/[$,]/g, '');

    // Convert the remaining string to a floating-point number
    return parseFloat(normalizedPrice) || 0;
  };

  const normalizeKey = (value) => {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value).trim().toUpperCase();
  };

  const sanitizeForFirestore = (data = {}) => {
    const clean = {};
    Object.keys(data || {}).forEach((key) => {
      const value = data[key];
      if (value !== undefined) {
        clean[key] = value;
      }
    });
    return clean;
  };

  const buildVehicleLookups = (vehiclesData = []) => {
    const byVin = new Map();
    const byOrder = new Map();

    vehiclesData.forEach((vehicle) => {
      const vinKey = normalizeKey(vehicle.strVin);
      if (vinKey) {
        byVin.set(vinKey, vehicle);
      }

      const orderKey = normalizeKey(vehicle.strOrdNbr);
      if (orderKey) {
        const existing = byOrder.get(orderKey) || [];
        existing.push(vehicle);
        byOrder.set(orderKey, existing);
      }
    });

    return { byVin, byOrder };
  };

  const asArray = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }
    return [];
  };

  const buildActiveOrderLookups = (orders = []) => {
    const byDan = new Map();
    const byFordOrder = new Map();
    const bySalesOrder = new Map();

    orders.forEach((order) => {
      const salesKey = normalizeKey(order.strSalesOrdNbr);
      if (salesKey && !bySalesOrder.has(salesKey)) {
        bySalesOrder.set(salesKey, order);
      }

      asArray(order.arrDans || []).forEach((dan) => {
        const key = normalizeKey(dan);
        if (key && !byDan.has(key)) {
          byDan.set(key, order);
        }
      });

      asArray(order.arrFordOrders || []).forEach((ord) => {
        const key = normalizeKey(ord);
        if (key && !byFordOrder.has(key)) {
          byFordOrder.set(key, order);
        }
      });
    });

    return { byDan, byFordOrder, bySalesOrder };
  };

  const findVehicle = (importedVehicle, orderLookups, vehicleLookups) => {
    const normSalesOrder = normalizeKey(importedVehicle.strSalesOrdNbr);
    const normVin = normalizeKey(importedVehicle.strVin);
    const normOrder = normalizeKey(importedVehicle.strOrdNbr);
    const normDan = normalizeKey(importedVehicle.nDAN);

    // 1. Try matching by Sales Order Number directly if provided
    if (normSalesOrder && orderLookups.bySalesOrder.has(normSalesOrder)) {
      // If it exists in vehicles already, find it
      const existing = vehicleLookups.byVin.get(normVin) ||
        (vehicleLookups.byOrder.get(normOrder) || []).find(v => normalizeKey(v.strYR) === normalizeKey(importedVehicle.strYR));

      if (existing) return { found: true, vehicle: existing };
      return { found: false, strSalesOrdNbr: normSalesOrder };
    }

    // 2. Try matching by VIN (Highest Accuracy)
    if (normVin) {
      const existingByVin = vehicleLookups.byVin.get(normVin);
      if (existingByVin) return { found: true, vehicle: existingByVin };
    }

    // 3. Try matching by Order Number (Ford Order Array in SalesOrders)
    // This is likely where your "7966" lives
    if (normOrder) {
      // A. Check if this vehicle already exists in the 'vehicles' collection
      const existingMatches = vehicleLookups.byOrder.get(normOrder) || [];
      const normYear = normalizeKey(importedVehicle.strYR);
      const byYear = existingMatches.find(v => normalizeKey(v.strYR) === normYear);

      if (byYear) return { found: true, vehicle: byYear };

      // B. Check if any Sales Order contains this Ford Order Number (Crucial Fix)
      if (orderLookups.byFordOrder.has(normOrder)) {
        return { found: false, strSalesOrdNbr: orderLookups.byFordOrder.get(normOrder).strSalesOrdNbr };
      }
    }

    // 4. Try matching by DAN
    if (normDan && orderLookups.byDan.has(normDan)) {
      return { found: false, strSalesOrdNbr: orderLookups.byDan.get(normDan).strSalesOrdNbr };
    }

    return { found: false, strSalesOrdNbr: null };
  };


  const excelDateToJSDatebak = (serial) => {
    if (isNaN(serial)) {
      return null;
    }
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    return new Date(utc_value * 1000);
  };

  const excelDateToJSDate = (input) => {
    if (!input) return null;

    // If the input is a number, assume it's an Excel serial date
    if (!isNaN(input)) {
      const serial = Number(input);
      if (serial < 1) return null; // Ensure it's a valid serial number

      const utc_days = Math.floor(serial - 25569);
      const utc_value = utc_days * 86400;
      return new Date(utc_value * 1000);
    }

    // If the input is a string, assume it's a date in MM/DD/YY or MM/DD/YYYY format
    if (typeof input === "string") {
      const parts = input.split("/").map(Number);

      if (parts.length !== 3) return null; // Invalid format

      let [month, day, year] = parts;

      // Handle both two-digit and four-digit years
      if (year < 100) {
        year += year < 50 ? 2000 : 1900; // Assume 2000s for <50, otherwise 1900s
      }

      const dateObject = new Date(year, month - 1, day);

      return isNaN(dateObject.getTime()) ? null : dateObject;
    }

    return null; // If none of the above conditions are met
  };

  const mapGMFields = (vehicle) => {
    const currentEventDate = excelDateToJSDate(vehicle["Current Event Date"]);
    const prodDate = excelDateToJSDate(vehicle["TPW"]);

    return {
      strOrdNbr: String(vehicle["Order #"]) || '',
      strSalesOrdNbr: vehicle["Sales Order Number"] || vehicle["Sales Order #"] || vehicle["Sales Order"] || vehicle["Contract Number"] || '',
      strGMConfigID: vehicle["GM Config ID"] || '',
      strOrderType: vehicle["Order Type"] || '',
      curVehMSRP: normalizePrice(vehicle["MSRP w/DFC†"]) || 0,
      dtProdDate: prodDate || null,
      strFactory: "GM",
      strMake: vehicle["Division"] || '',
      strModel: vehicle["Model"] || vehicle["Model Code"] || '',
      strColor: vehicle["Color"] || '',
      strManStat: vehicle["Current Event"] || '',
      strCustName: vehicle["Business Customer Name"] || '',
      strYR: vehicle["Model Year"] || '',
      strDelivStat: vehicle["Deliver Vehicle"] || '',
      curVehIncent: vehicle["Lookup Incentives by VIN"] || 0,
      lstrCustNotes: vehicle["Remarks"] || '',
      dtCurrentEvent: currentEventDate || null,
      nDAN: vehicle["DAN"] || '',
      strVin: vehicle["VIN"] || '',
      //createdDate: Timestamp.now(), Add this line for the current Firestore timestamp
    };
  };

  const mapFordFields = (vehicle) => {
    const buildDate = excelDateToJSDate(vehicle["BuildDate"]);
    const receiptDate = excelDateToJSDate(vehicle["Receipt Date"]);
    const prodDate = excelDateToJSDate(vehicle["BuildDate"] || vehicle["BuildWeek"]);
    return {
      strOrdNbr: String(vehicle["Order"]) || '',
      strSalesOrdNbr: vehicle["Sales Order Number"] || vehicle["Sales Order #"] || vehicle["Sales Order"] || '',
      strGMConfigID: vehicle["Reservation ID"] || '', // Assuming this as a placeholder for Ford Config ID
      strOrderType: vehicle["Type"] || '',
      strFactory: 'Ford', // Make is Ford for all Ford reports
      strMake: 'Ford',
      strModel: vehicle["Body"] || '',
      strColor: vehicle["Paint"] || '',
      strManStat: vehicle["Status"] || '',
      strYR: vehicle["Year"] || '',
      strDelivStat: '', // Delivery Status not provided in Ford headers
      curVehIncent: 0, // Incentives not provided in Ford headers
      lstrCustNotes: vehicle["SVS Reason"] || '',
      dtCurrentEvent: buildDate || null, // Assuming build date as current event date
      nDAN: '', // DAN not provided in Ford headers
      strVin: vehicle["VIN"] || '',
      dtProdDate: prodDate || null,
      //createdDate: Timestamp.now(),
    };
  };

  const handleDeleteClick = (vehicle) => {
    setShowDeleteModal(true);
  };

  const handleDetailsClick = (vehicle) => {
    setVehicleToShow(vehicle);
    setShowDetailModal(true);
  };

  const handleAddClick = () => {
    setShowAddModal(true);
  };

  const confirmDelete = async () => {
    try {
      // Loop through each selected vehicle and delete them one by one
      for (const vehicle of selectedVehicles) {
        await deleteData('vehicles', vehicle.id);
      }

      // Filter out the deleted vehicles from the state
      const updatedVehicles = vehicles.filter(vehicle => !selectedVehicles.includes(vehicle));
      setVehicles(updatedVehicles);
      setFilteredVehicles(updatedVehicles); // Ensure UI sync
      setTotalRows(updatedVehicles.length);
      setSelectedVehicles([]); // Clear the selection

      setShowDeleteModal(false); // Close the modal after deletion
    } catch (error) {
      console.error("Error deleting vehicles:", error);
    }
  };

  // Helper at top of component
  const isApproved = v => v.approved === true;

  // toggleVehicleSelection
  const toggleVehicleSelection = (vehicle) => {
    if (selectedVehicles.length > 0) {
      const initial = isApproved(selectedVehicles[0]);
      if (isApproved(vehicle) !== initial) {
        alert('Can only mix vehicles with the same approval status.');
        return;
      }
    }

    if (selectedVehicles.includes(vehicle)) {
      setSelectedVehicles(s => s.filter(v => v !== vehicle));
    } else {
      setSelectedVehicles(s => [...s, vehicle]);
    }
  }; 

  const toggleSelectAll = () => {
    // If we’re already in “select all” mode, clear everything
    if (selectAll) {
      setSelectedVehicles([]);
      setSelectAll(false);
      return;
    }

    // Were we starting from zero selection?
    const isInitial = selectedVehicles.length === 0;

    // Decide target: existing status if any, else unapproved (false)
    const target = !isInitial
      ? isApproved(selectedVehicles[0])
      : false;

    // Grab only those matching target
    const toSelect = currentRows.filter(v => isApproved(v) === target);

    // Only alert on that very first select-all if there was a mix
    if (isInitial && toSelect.length !== currentRows.length) {
      alert(
        `This page has both approved and unapproved vehicles.\n` +
        `Selecting only the unapproved ones.`
      );
    }

    setSelectedVehicles(toSelect);
    setSelectAll(true);
  };

  // Customers visible to this user (from userProfile.customers) as {value,label} using strCustNbr -> strCustName
  const getCustomerOptionsForUser = () => {
    const allowed = userProfile?.customers || [];
    return allowed
      .map(nbr => customers.find(c => c?.strCustNbr === nbr))
      .filter(Boolean)
      .map(c => ({ value: c.strCustNbr, label: c.strCustName }));
  };

  const openQuoteModal = (selVehicles) => {
    // Normalize
    const plain = (selVehicles || []).map(toPlain);

    // VIN filter + dedupe
    const withVinRaw = plain.filter(v => (v?.strVin || '').trim().length > 0);
    const noVinCount = plain.length - withVinRaw.length;

    const seen = new Set();
    const withVin = withVinRaw.filter(v => {
      const vin = v.strVin.trim();
      if (seen.has(vin)) return false;
      seen.add(vin);
      return true;
    });
    const dedupedAway = withVinRaw.length - withVin.length;

    setNotifyVehicles(withVin);
    setNotifyCounts({ total: plain.length, withVin: withVin.length, noVin: noVinCount, deduped: dedupedAway });

    // Preselect first available customer (if any)
    const opts = getCustomerOptionsForUser();
    setSelectedCustomerNbr(opts?.[0]?.value || '');

    setShowQuoteModal(true);
  };

  const sendQuoteEmail = async () => {
    try {
      if (!selectedCustomerNbr) {
        alert('Please select a customer.');
        return;
      }

      const chosenCustomer = customers.find(c => c.strCustNbr === selectedCustomerNbr);

      // Replace strModel with friendly name for CSV
      const vehiclesForCsv = notifyVehicles.map(v => ({
        ...v,
        strModel: resolveModelName(v, modelCodes),
      }));

      const fileName = `stock_order_${selectedCustomerNbr}_${new Date().toISOString().slice(0, 10)}.csv`;

      const attachments = makeCsvAttachmentFromVehicles(
        vehiclesForCsv,
        fileName,
        { stripColorPrefix: true }
      );
/*
      await sendInternalEmail({
        toRecipients: ["mark@dahlhauser.net"],
        subject: `Quote Requested for ${escapeHtml(chosenCustomer?.strCustName || selectedCustomerNbr)} by ${escapeHtml(userProfile?.name || '')}`,
        htmlBody: `
        <p>Hi Team,</p>
        <p>A quote has been requested for <strong>${escapeHtml(chosenCustomer?.strCustName || selectedCustomerNbr)}</strong> by ${escapeHtml(userProfile?.name || '')} (${escapeHtml(userProfile?.email)}).</p>
        <p>Vehicles are attached.</p>
      `,
        attachments,
        replyTo: 'info@dahlhauser.net',
      });

*/      
      await sendInternalEmail({
        toRecipients: [
          "mark@dahlhauser.net",
          "ddelesline@hardyautomotive.com",
          "cdeems@hardyautomotive.com",
          "aharris@hardyautomotive.com"
        ],
        subject: `Fleet Quote Request: ${escapeHtml(chosenCustomer?.strCustName || selectedCustomerNbr)}`,
        replyTo: 'info@dahlhauser.net',
        attachments,
        htmlBody: `
    <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px;">
      <h2 style="color: #2c3e50; border-bottom: 2px solid #eee; padding-bottom: 10px;">New Fleet Quote Request</h2>
      <p>Hi Team,</p>
      <p>A new fleet quote request has been generated. Please review the attached documentation.</p>
      
      <div style="background-color: #f9f9f9; padding: 15px; border-radius: 5px; margin: 20px 0;">
        <h3 style="margin-top: 0; color: #2c3e50;">Request Details</h3>
        <p style="margin: 5px 0;"><strong>Customer:</strong> ${escapeHtml(chosenCustomer?.strCustName || selectedCustomerNbr)}</p>
        <p style="margin: 5px 0;"><strong>Requested By:</strong> ${escapeHtml(userProfile?.name || 'Unknown')} 
           <a href="mailto:${escapeHtml(userProfile?.email)}">(${escapeHtml(userProfile?.email)})</a>
        </p>
        <p style="margin: 5px 0;"><strong>Date:</strong> ${new Date().toLocaleDateString()}</p>
      </div>
      
      <div style="margin-top: 30px; font-size: 12px; color: #777;">
        <p>This is an automated notification from your dealership management portal.</p>
      </div>
    </div>
  `,
      });

      setShowQuoteModal(false);
      alert("Quote request sent!");
    } catch (err) {
      console.error("Failed sending mail:", err);
      alert("Error sending email");
    }
  };


  const togglePaidSelected = () => {
    if (paidSelected) {
      setPaidSelected(false);
    } else {
      setPaidSelected(true);
    }
  };

  const handleBulkEditHide = () => {
    setSelectedVehicles([]);
    setShowBulkEditModal(false)
  }

  const handleBulkEditSubmit = async (updatedFields) => {
    console.log('Bulk edit submit with fields:', updatedFields);
    console.log('Selected vehicles for bulk edit:', selectedVehicles);
    const promises = selectedVehicles.map(vehicle => {
      // Create an updated vehicle object with only changed fields
      const updatedVehicle = {};

      // Loop through the updatedFields and only add the fields that have changed or are not empty
      Object.keys(updatedFields).forEach(field => {
        if (updatedFields[field] !== '' && updatedFields[field] !== vehicle[field]) {
          updatedVehicle[field] = updatedFields[field]; // Add only changed fields
        }
      });

      // Update only if there are fields to update
      if (Object.keys(updatedVehicle).length > 0) {
        return updateData('vehicles', vehicle.id, updatedVehicle);
      }

      return Promise.resolve(); // No changes, so return a resolved promise
    });

    try {
      await Promise.all(promises);
      const vehicleData = selectedOrder
        ? await queryData('vehicles', 'strSalesOrdNbr', '==', selectedOrder.strSalesOrdNbr)
        : await getData('vehicles');
      setVehicles(vehicleData);
      setShowBulkEditModal(false);
    } catch (error) {
      console.error('Error updating vehicles:', error);
    }
  };


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredVehicles.slice(indexOfFirstRow, indexOfLastRow);

  // helper: unwrap Firestore snapshots if they’re passed in
  const toPlain = (v) =>
    typeof v?.data === "function" ? { id: v.id, ...v.data() } : v;

  // helper: resolve model name from your mapping with fallbacks
  const resolveModelName = (vehicle, modelCodes = {}) => {
    const factory = (vehicle?.strFactory ?? "").trim();
    const model = (vehicle?.strModel ?? "").trim();
    if (!factory && !model) return "";

    const exactKey = `${factory} - ${model}`;
    const shortKey = `${factory} - ${model.substring(0, 3)}`;

    return modelCodes[exactKey] || modelCodes[shortKey] || model;
  };

  const escapeHtml = (s = "") =>
    String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;", "'": "&#39;" }[c]));
  

  const handleRequestQuote = () => {
    if (selectedVehicles.length === 0) {
      alert("Please select at least one vehicle to request a quote.");
      return;
    }
    openQuoteModal(selectedVehicles);
  };

  const renderUpfitterPanel = (vehicle) => {
    const entry = getUpfitterEntryForUser(vehicle);

    if (!entry) {
      return (
        <div className="p-3">
          <em>No items for your upfitter on this vehicle.</em>
        </div>
      );
    }

    const items = Array.isArray(entry.items) ? entry.items : [];
    const total = items.reduce((sum, it) => sum + (parseFloat(it?.amount) || 0), 0);

    return (
      <div className="p-3">
        <div className="mb-2">
          <strong>{entry.upfitter || 'Upfitter'} ({entry.upfitterNbr})</strong>
        </div>

        <Row className="mb-2">
          <Col md={3}><strong>Status</strong></Col>
          <Col md={3}><strong>Sent To Upfitter Date</strong></Col>
          <Col md={3}><strong>ETA Date</strong></Col>
          <Col md={3}><strong>Completed Date</strong></Col>
        </Row>
        <Row className="mb-3">
          <Col md={3}>
            {entry.upfitterStatusText ||
              getUpfitterStatus?.(entry.upfitterStatus) ||
              (entry.upfitterStatus || '')}
          </Col>
          <Col md={3}>{formatMaybeDate(entry.dtSentToUpfitter)}</Col>
          <Col md={3}>{formatMaybeDate(entry.dtUpfitterETA)}</Col>
          <Col md={3}>{formatMaybeDate(entry.dtUpfitterComp)}</Col>
        </Row>

        <div className="table-responsive">
          <Table size="sm" bordered hover>
            <thead>
              <tr>
                <th style={{ width: '70%' }}>Item Description</th>
                <th style={{ width: '30%', textAlign: 'right' }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr>
                  <td colSpan={2}><em>No items.</em></td>
                </tr>
              )}
              {items.map((it, idx) => (
                <tr key={idx}>
                  <td>{it?.description || ''}</td>
                  <td style={{ textAlign: 'right' }}>{formatCurrency(parseFloat(it?.amount) || 0)}</td>
                </tr>
              ))}
              {items.length > 0 && (
                <tr>
                  <td style={{ textAlign: 'right' }}><strong>Total</strong></td>
                  <td style={{ textAlign: 'right' }}><strong>{formatCurrency(total)}</strong></td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    );
  };



  const renderPaginationItems = () => {
    const pageNumbers = [];
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const maxPagesToShow = 5;
    let startPage = Math.max(currentPage - Math.floor(maxPagesToShow / 2), 1);
    let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(endPage - maxPagesToShow + 1, 1);
    }

    pageNumbers.push(
      <Pagination.First key="first" onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
    );
    pageNumbers.push(
      <Pagination.Prev key="prev" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
    );

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i}
        </Pagination.Item>
      );
    }

    pageNumbers.push(
      <Pagination.Next key="next" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
    );
    pageNumbers.push(
      <Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
    );

    return pageNumbers;
  };

  if (isDataLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 240 }}>
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  return (
    <>
      <InputGroup>
        <DropdownButton
          variant="outline-secondary"
          title={searchOperator.toUpperCase()}
          id="vehicle-search-operator"
          onSelect={handleSearchOperatorChange}
          className="me-1"
        >
          <Dropdown.Item eventKey="or">Match any term</Dropdown.Item>
          <Dropdown.Item eventKey="and">Match all terms</Dropdown.Item>
        </DropdownButton>
        <InputGroup.Text id="search-addon"><Search /></InputGroup.Text>
        <FormControl
          placeholder="Search vehicles (comma-separated)..."
          value={searchQuery}
          onChange={handleSearchInputChange}
        />
      </InputGroup>

      {/* Wrap the table in a responsive container */}
      <div className="table-responsive" style={{ minHeight: '300px' }}>
        <Table hover style={{ whiteSpace: 'nowrap' }}>
          <thead>
            <tr>
              {addButtonActive ? (
                <th>
                  <div className="d-flex align-items-center">
                    <Form.Check
                      type="checkbox"
                      checked={selectAll}
                      onChange={toggleSelectAll}
                      className="me-2"
                    />
                    {!allVehicles && (
                        <OverlayTrigger
                          placement="top"
                          /* 1. Dynamic Tooltip text based on selection length */
                          overlay={
                            <Tooltip id="tooltip-top">
                              {selectedVehicles.length > 0 ? "Disabled" : "Add Vehicle"}
                            </Tooltip>
                          }
                        >
                          <span> {/* Wrapper needed because disabled elements don't trigger tooltips in some Bootstrap versions */}
                            <Button
                              /* 2. Disable button if selectedVehicles has items */
                              disabled={selectedVehicles.length > 0}
                              onClick={() => {
                                handleAddClick();
                                /* 3. Reset selectedVehicles to empty array */
                                setSelectedVehicles([]);
                                setSelectAll(false);
                              }}
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                              className="icon-hover"
                              style={{ padding: '2px 4px' }}
                              variant="link"
                            >
                              {isHovered ? <PlusCircleFill size={20} /> : <PlusCircle size={20} />}
                            </Button>
                          </span>
                        </OverlayTrigger>
                      )
                    }
                    {/* Import Vehicles Button */}
                    {allVehicles && (
                      <>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">Import Vehicles</Tooltip>}
                        >
                          <Button
                            onClick={() => document.getElementById('file-input').click()}
                            variant="white"
                            style={{ padding: '0px 0px' }}
                          >
                            <ArrowBarUp size={20} color="blue" />
                          </Button>
                        </OverlayTrigger>
                        <input
                          type="file"
                          id="file-input"
                          style={{ display: 'none' }}
                          onChange={handleFileChange}
                          accept=".xlsx, .xls, csv"
                        />
                      </>
                    )}

                    {/* Bulk Edit Button */}
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Edit Vehicle(s)</Tooltip>}
                    >
                      <Button
                        onClick={() => handleBulkEditClick()}
                        variant="white"
                        style={{ padding: '0px 0px' }}
                      >
                        <Wrench size={18} color="black" />
                      </Button>
                    </OverlayTrigger>

                    {/* Bulk Delete Button */}
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Delete Vehicle(s)</Tooltip>}
                    >
                      <Button
                        onClick={() => handleDeleteClick(selectedVehicles)}
                        variant="white"
                        style={{ padding: '0px 0px' }}
                      >
                        <Trash size={18} color="red" />
                      </Button>
                    </OverlayTrigger>
                    {/* Bulk Export Button */}
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Export Selected Vehicles</Tooltip>}
                    >
                      <Button
                        onClick={handleExportToXLSX}
                        variant="white"
                        style={{ padding: '0px 0px' }}
                      >
                        <FiletypeXlsx size={18} color="green" />
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Paid Only</Tooltip>}
                    >
                      <Button
                        onClick={() => togglePaidSelected()}
                        variant="white"
                        style={{ padding: '0px 0px' }}
                      >
                        {paidSelected ? <CurrencyDollar color="green" /> : <CurrencyDollar />}
                      </Button>
                    </OverlayTrigger>
                  </div>
                </th>
              ) : (
                  <th>
                    <div className="d-flex align-items-center">
                      <Form.Check
                        type="checkbox"
                        checked={selectAll}
                        onChange={toggleSelectAll}
                        className="me-2"
                      />
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-top">Export Selected Vehicles</Tooltip>}
                      >
                        <Button
                          onClick={handleExportToXLSX}
                          variant="white"
                          style={{ padding: '0px 0px' }}
                        >
                          <FiletypeXlsx size={18} color="green" />
                        </Button>
                      </OverlayTrigger>    

                      {globalSection === 'customer' && selectedOrder?.strSalesOrdNbr === 'Stock' && (
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-quote">Request Quote</Tooltip>}>
                          <Button
                            variant="white"
                            style={{ padding: '0px 5px' }}
                            onClick={handleRequestQuote}
                          >
                            <EnvelopeArrowUp size={18} color="blue" />
                          </Button>
                        </OverlayTrigger>
                      )}                 
                    </div>
                  </th>
              )}
              {allVehicles && (
                <th>
                  <div className="d-flex justify-content-between align-items-center">
                    <span>SO #</span>
                    <Button onClick={() => handleSortClick('strSalesOrdNbr')} variant='white'><ArrowDownUp /></Button>
                  </div>
                </th>
              )}
              <th>
                <div className="d-flex justify-content-between align-items-center">
                  <span>Order #</span>
                  <Button onClick={() => handleSortClick('strOrdNbr')} variant='white'><ArrowDownUp /></Button>
                </div>
              </th>
              {addButtonActive && (
                <th>
                  <div className="d-flex justify-content-between align-items-center">
                    <span>DAN</span>
                    <Button onClick={() => handleSortClick('nDAN')} variant='white'><ArrowDownUp /></Button>
                  </div>
                </th>
              )

              }
              {/*
              <th>
                <div className="d-flex justify-content-between align-items-center">
                  <span>VIN</span>
                  <Button onClick={() => handleSortClick('strVin')} variant='white'><ArrowDownUp /></Button>
                </div>
              </th>
              */}
              {allVehicles && (
                <th>
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Customer Name</span>
                    <Button onClick={() => handleSortClick('customerName')} variant='white'>
                      <ArrowDownUp />
                    </Button>
                  </div>
                </th>
              )}
              {addButtonActive ? (
                <th>
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Stock #</span>
                    <Button onClick={() => handleSortClick('strStockNbr')} variant='white'><ArrowDownUp /></Button>
                  </div>
                </th>
              ) : (
                <th>
                  <div className="d-flex justify-content-between align-items-center">
                    <span>VIN</span>
                    <Button onClick={() => handleSortClick('strVin')} variant='white'><ArrowDownUp /></Button>
                  </div>
                </th>
              )}
              <th>
                <div className="d-flex justify-content-between align-items-center">
                  <span>Make</span>
                  <Button onClick={() => handleSortClick('strMake')} variant="white">
                    <ArrowDownUp />
                  </Button>
                </div>
              </th>
              <th>
                <div className="d-flex justify-content-between align-items-center">
                  <span>Model</span>
                  <Button onClick={() => handleSortClick('model')} variant='white'><ArrowDownUp /></Button>
                </div>
              </th>
              <th>
                <div className="d-flex justify-content-between align-items-center">
                  <span>ETA</span>
                  <Button onClick={() => handleSortClick('eta')} variant="white">
                    <ArrowDownUp />
                  </Button>
                  <Dropdown show={showDateFilter} onToggle={() => setShowDateFilter(!showDateFilter)}>
                    <Dropdown.Toggle variant="white" id="eta-date-filter">
                      <Funnel />
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end" style={{ padding: '10px', minWidth: '200px' }}>
                      <Form.Group>
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={etaStartDate ? etaStartDate.toISOString().slice(0, 10) : ''} // Set value
                          onChange={(e) => setEtaStartDate(e.target.value ? new Date(e.target.value) : null)}
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={etaEndDate ? etaEndDate.toISOString().slice(0, 10) : ''} // Set value
                          onChange={(e) => setEtaEndDate(e.target.value ? new Date(e.target.value) : null)}
                        />
                      </Form.Group>
                      <Button
                        variant="primary"
                        className="mt-2"
                        onClick={() => setShowDateFilter(false)} // Close the dropdown
                      >
                        Apply
                      </Button>
                      <Button
                        variant="outline-primary"
                        className="mt-2 ms-2"
                        onClick={() => {
                          setEtaStartDate(null);
                          setEtaEndDate(null);
                        }} // Reset dates
                      >
                        Clear
                      </Button>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </th>
              <th>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="me-1">Status</span>
                  <Button
                    onClick={() => handleSortClick('status')}
                    variant='white'
                    className="me-1" // Reduce the space between Button and Dropdown
                    style={{ padding: '1px 2px' }} // Optional: Adjust button padding
                  >
                    <ArrowDownUp />
                  </Button>
                  <Dropdown>
                    <Dropdown.Toggle variant="white" id="eta-date-filter">
                      <Funnel />
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end" style={{ padding: '10px', minWidth: '200px' }}>
                      {['Vehicle Ordered', 'Scheduled', 'Produced', 'In Transit', 'On the Ground', 'Customer Signed', 'Ready for Upfitter', 'Vehicle at Upfitter', 'Delayed at Upfitter', 'Vehicle Returned from Upfitter', 'Delivered', 'Complete', 'All'].map(status => (
                        <Dropdown.Item
                          key={status}
                          active={selectedVehicleDisplayedStatus.includes(status)}
                          onClick={() => handleVehicleDisplayedStatusSelect(status)}
                        >
                          {status}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  <DropdownButton
                    as={InputGroup.Append}
                    variant="white"
                    title={selectedVehicleStatuses}
                    id="input-group-dropdown-vehicle-status"
                    drop="down"
                    menuAlign="right"
                    container="body"
                  >
                    {['Active', 'Complete', 'All'].map(status => (
                      <Dropdown.Item
                        key={status}
                        active={selectedVehicleStatuses.includes(status)}
                        onClick={() => handleVehicleStatusSelect(status)}
                      >
                        {status}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                </div>

              </th>
              <th>
                <div style={{ position: 'relative', display: 'inline-block', width: '30px', height: '30px' }}>
                  {/* Circle Icon */}
                  <CircleFill
                    size={30}
                    color={getCircleColor(calculateGreenPercentage())}  // Use the status color
                  />
                  {/* Text inside the circle */}
                  <span style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: 'white',
                    fontSize: '12px',
                    fontWeight: 'bold',
                  }}>
                    {calculateGreenPercentage()}{"%"} {/* Replace `someText` with the desired text */}
                  </span>
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            {currentRows.map(vehicle => (
              <React.Fragment key={vehicle.id}>
                <tr
                  onClick={() => (upfitterMode ? toggleExpand(vehicle.id) : handleVehicleRowClick(vehicle))}
                  className="align-middle"
                  style={{ cursor: upfitterMode ? 'pointer' : 'default' }}
                >
                  <td>
                    <div className="d-flex align-items-center">
                      <Form.Check
                        type="checkbox"
                        className="me-2"
                        checked={selectedVehicles.includes(vehicle)}
                        onChange={() => toggleVehicleSelection(vehicle)}
                        onClick={(e) => e.stopPropagation()}
                      />

                      {addButtonActive && (
                        <>
                          <OverlayTrigger placement="top" overlay={<Tooltip id="tt-details">Details</Tooltip>}>
                            <Button
                              onClick={(e) => { e.stopPropagation(); handleDetailsClick(vehicle); }}
                              variant="white"
                              style={{ padding: '0px 0px' }}
                            >
                              <InfoCircle color="blue" />
                            </Button>
                          </OverlayTrigger>

                          <OverlayTrigger placement="top" overlay={<Tooltip id={`tt-bill-${vehicle.id}`}>Bill Out</Tooltip>}>
                            <Button
                              variant="link"
                              size="sm"
                              onClick={(e) => { e.stopPropagation(); handleBillOutClick(vehicle); }}
                            >
                              <EnvelopeArrowUp />
                            </Button>
                          </OverlayTrigger>

                          {getDOASReq(vehicle.strSalesOrdNbr) && (
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tt-contract">Contract Fee</Tooltip>}>
                              <span style={{ marginLeft: '10px' }} onClick={(e) => e.stopPropagation()}>
                                <Buildings />
                              </span>
                            </OverlayTrigger>
                          )}

                          {vehicle.approved && (
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tt-approved">Approved</Tooltip>}>
                              <span style={{ marginLeft: '10px' }} onClick={(e) => e.stopPropagation()}>
                                <CheckCircle />
                              </span>
                            </OverlayTrigger>
                          )}
                        </>
                      )}

                      {!upfitterMode && vehicle.dtPaidDate && (
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tt-paid">Paid</Tooltip>}>
                          <span style={{ marginLeft: '10px' }} onClick={(e) => e.stopPropagation()}>
                            <CurrencyDollar />
                          </span>
                        </OverlayTrigger>
                      )}

                      {upfitterMode && (
                        <span
                          className="me-2"
                          onClick={(e) => { e.stopPropagation(); toggleExpand(vehicle.id); }}
                        >
                          {expandedRows.has(vehicle.id) ? <ChevronDown /> : <ChevronRight />}
                        </span>
                      )}
                    </div>
                  </td>

                  {allVehicles && (
                    <td>
                      <OverlayTrigger placement="top" overlay={<Tooltip id="tt-so">Navigate to Sales Order</Tooltip>}>
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={(e) => { e.stopPropagation(); handleSalesOrderClick(vehicle.strSalesOrdNbr); }}
                        >
                          {vehicle.strSalesOrdNbr}
                        </Button>
                      </OverlayTrigger>
                    </td>
                  )}

                  <td>{vehicle.strOrdNbr}</td>

                  {addButtonActive && (<td>{vehicle.nDAN}</td>)}

                  {allVehicles && (
                    <td style={{ maxWidth: '50px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      <OverlayTrigger placement="top" overlay={<Tooltip id="tt-cust">{getCustomerName(vehicle.strSalesOrdNbr)}</Tooltip>}>
                        <span onClick={(e) => e.stopPropagation()}>{getCustomerName(vehicle.strSalesOrdNbr)}</span>
                      </OverlayTrigger>
                    </td>
                  )}

                  {addButtonActive ? (
                    <td>
                      {vehicle.strStockNbr
                        ? vehicle.strStockNbr
                        : vehicle.strVin && vehicle.strVin.length >= 8
                          ? vehicle.strVin.slice(-8)
                          : vehicle.strVin || ""
                      }
                    </td>
                  ) : (
                    <td>{vehicle.strVin}</td>
                  )}

                  <td>{vehicle.strYR} {vehicle.strMake}</td>

                  <td>
                    {modelCodes[
                      (vehicle.strFactory ? vehicle.strFactory : "") + " - " + (vehicle.strModel ? vehicle.strModel : "")
                    ] ||
                      modelCodes[
                      (vehicle.strFactory ? vehicle.strFactory : "") + " - " + (vehicle.strModel ? vehicle.strModel.substring(0, 3) : "")
                      ] ||
                      modelCodes[
                      (vehicle.strMake ? capitalizeFirstLetter(vehicle.strMake) : "") + " - " + (vehicle.strModel ? vehicle.strModel.substring(0, 3) : "")
                      ] ||
                      modelCodes[
                      ("GM") + " - " + (vehicle.strModel ? vehicle.strModel.substring(0, 3) : "")
                      ] ||
                      (vehicle.strModel || "")
                    }
                  </td>

                  <td>{getETAStr(vehicle)}</td>

                  <td style={{ maxWidth: '50px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tt-status">{getDisplayedStatus(vehicle)}</Tooltip>}>
                      <span onClick={(e) => e.stopPropagation()}>{getDisplayedStatus(vehicle)}</span>
                    </OverlayTrigger>
                  </td>

                  <td>
                    <CircleFill size={30} color={getStatusColor(vehicle)} />
                  </td>
                </tr>

                {upfitterMode && expandedRows.has(vehicle.id) && (
                  <tr className="bg-light">
                    <td colSpan={getDetailColSpan()}>
                      {renderUpfitterPanel(vehicle)}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </div>

      <div className={`d-flex justify-content-between align-items-center my-1 ${selectedOrder ? 'mb-1' : (rowsPerPage === 15 ? 'mb-3' : 'mb-5')}`} style={{ flexWrap: 'wrap' }}>
        <div>
          Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, totalRows)} of {totalRows} rows
        </div>
        <div className="d-flex align-items-center">
          <span className="me-2">Rows per page:</span>
          <Form.Select value={rowsPerPage} onChange={handleRowsPerPageChange} style={{ width: 'auto' }}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={250}>250</option>
            <option value={999999}>All</option>
          </Form.Select>
        </div>
        <Pagination className="mb-0">
          {renderPaginationItems()}
        </Pagination>
      </div>

      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <Spinner animation="border" variant="primary" />
          {currentImportSheet && (
            <div style={{ marginTop: '16px', fontWeight: 600 }}>
              Now importing... {currentImportSheet}
            </div>
          )}
          {currentVehicleInfo && (
            <div style={{ marginTop: currentImportSheet ? '8px' : '16px', textAlign: 'center' }}>
              <div style={{ fontWeight: 600 }}>
                {[currentVehicleInfo.strYR, currentVehicleInfo.strMake, currentVehicleInfo.strModel]
                  .filter(Boolean)
                  .join(' ')}
              </div>
              {currentVehicleInfo.strVin && (
                <div style={{ marginTop: '4px', fontFamily: 'monospace' }}>
                  {currentVehicleInfo.strVin}
                </div>
              )}
            </div>
          )}
        </div>
      )}


      {/* Delete Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedVehicles.length > 1
            ? `Are you sure you want to delete these ${selectedVehicles.length} vehicles?`
            : "Are you sure you want to delete this vehicle?"}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={confirmDelete}>Delete</Button>
        </Modal.Footer>
      </Modal>

      {/* Add Modal */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Add Vehicle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <VehicleForm
            salesOrderNumber={(allVehicles ? null : selectedOrder?.strSalesOrdNbr)}
            onVehicleAdded={handleVehicleAdded}
            modalCodes={modelCodes}
            addVehicle={true}
          />
        </Modal.Body>
      </Modal>

      {/* Detail Modal */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Vehicle Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {vehicleToShow && (
            <div style={{ wordWrap: "break-word", whiteSpace: "pre-wrap" }}>
              <Row>
                <Col xs={3}><strong>Last Updated</strong></Col>
                <Col xs={3}>{formatDateUTC(vehicleToShow.lastUpdated) || ''}</Col>
                <Col xs={3}></Col>
                <Col xs={3}></Col>
              </Row>
              <Row>
                <Col xs={3}><strong>Vehicle Ordered</strong></Col>
                <Col xs={3}>{formatDateUTC(vehicleToShow.createdDate) || ''}</Col>
                <Col xs={3}></Col>
                <Col xs={3}></Col>
              </Row>
              <Row>
                <Col xs={9}> </Col>
              </Row>
              <Row>
                <Col xs={3}><strong>Sales Order #</strong></Col>
                <Col xs={3}>{vehicleToShow.strSalesOrdNbr || ''}</Col>
                <Col xs={3}></Col>
                <Col xs={3}></Col>
              </Row>
              <Row>
                <Col xs={3}><strong>Order #</strong></Col>
                <Col xs={3}>{vehicleToShow.strOrdNbr || ''}</Col>
                <Col xs={3}><strong>Stock #</strong></Col>
                <Col xs={3}>{vehicleToShow.strStockNbr || vehicleToShow.strVin?.slice(-8) || ""}</Col>
              </Row>
              <Row>
                <Col xs={3}><strong>DAN</strong></Col>
                <Col xs={3}>{vehicleToShow.nDAN || ''}</Col>
                <Col xs={3}><strong>PO #</strong></Col>
                <Col xs={3}>{getSalesOrdPONbr(vehicleToShow.strSalesOrdNbr)}</Col>
              </Row>
              <Row>
                <Col xs={3}><strong>VIN</strong></Col>
                <Col xs={3}>{vehicleToShow.strVin || ''}</Col>
                <Col xs={3}><strong>PO Line #</strong></Col>
                <Col xs={3}>{vehicleToShow.strPONbr || ''}</Col>
              </Row>
              <Row>
                <Col xs={3}><strong>Year</strong></Col>
                <Col xs={3}>{vehicleToShow.strYR || ''}</Col>
                <Col xs={3}></Col>
                <Col xs={3}></Col>
              </Row>
              <Row>
                <Col xs={3}><strong>Make</strong></Col>
                <Col xs={3}>{vehicleToShow.strMake || ''}</Col>
                <Col xs={3}><strong>Color</strong></Col>
                <Col xs={3}>{vehicleToShow.strColor || ''}</Col>
              </Row>
              <Row>
                <Col xs={3}><strong>Model Code</strong></Col>
                <Col xs={3}>{vehicleToShow.strModel || ''}</Col>
                <Col xs={3}><strong>Model Name</strong></Col>
                <Col xs={3}>{modelCodes[
              (vehicleToShow.strFactory ? vehicleToShow.strFactory : "") + " - " + (vehicleToShow.strModel ? vehicleToShow.strModel : "")
            ] ||
              modelCodes[
              (vehicleToShow.strFactory ? vehicleToShow.strFactory : "") + " - " + (vehicleToShow.strModel ? vehicleToShow.strModel.substring(0, 3) : "")
              ] ||
              (vehicleToShow.strModel || "")}</Col>
              </Row>
              {/* Row 1 */}
              <Row>
                <Col xs={3}><strong>Factory Status</strong></Col>
                <Col xs={3}>{vehicleToShow.strManStat || ''}</Col>
                <Col xs={3}><strong>Factory ETA Date</strong></Col>
                <Col xs={3}>{formatDateUTC(vehicleToShow.dtManETA) || ''}</Col>
              </Row>
              {/* Row 2 */}
              <Row>
                <Col xs={3}><strong>Manual Status</strong></Col>
                <Col xs={3}>{vehicleToShow.strManualStat || ''}</Col>
                <Col xs={3}><strong>Manual ETA Date</strong></Col>
                <Col xs={3}>{formatDateUTC(vehicleToShow.dtManualETA) || ''}</Col>
              </Row>
              {/* Row 3 */}
              <Row>
                <Col xs={3}><strong>Drop Ship Ind</strong></Col>
                <Col xs={3}>{vehicleToShow.bDropInd ? 'Yes' : 'No'}</Col>
                <Col xs={3}><strong>Dropship Location</strong></Col>
                <Col xs={3}>{vehicleToShow.strDropLoc || ''}</Col>
              </Row>
              <Row>
                <Col xs={9}> </Col>
              </Row>
              {/* Row 4 */}
              <Row>
                <Col xs={3}><strong>Keys</strong></Col>
                <Col xs={3}>{vehicleToShow.curKeys || ''}</Col>
                <Col xs={3}></Col>
                <Col xs={3}></Col>
              </Row>
              <Row>
                <Col xs={9}> </Col>
              </Row>
              {/* Row 5 */}
              <Row>
                <Col xs={3}><strong>Vehicle Price</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curVehSalePrice)}</Col>
                <Col xs={3}><strong>Vehicle MSRP</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curVehMSRP)}</Col>
              </Row>
              <Row>
                <Col xs={3}><strong>Vehicle Cost</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curVehCOS)}</Col>
                <Col xs={3}><strong>VQ2\Hold Back:</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curVQ2)}</Col>
              </Row>
              {/* Row 6 */}
              <Row>
                <Col xs={3}><strong>Upfit Cost</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curUpfitCost)}</Col>
                <Col xs={3}><strong>Accessories</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.currAccess)}</Col>
              </Row>
              {/* Row 7 */}
              <Row>
                <Col xs={3}><strong>Incentives</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curVehIncent)}</Col>
                <Col xs={3}><strong>Rebate</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curRebate)}</Col>
              </Row>
              <Row>
                <Col xs={3}><strong>Contract Fee</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curDoas)}</Col>
                <Col xs={3}></Col>
                <Col xs={3}></Col>
              </Row>
              {/* Row 8 */}
              <Row>
                <Col xs={3}><strong>Tag & Title</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curTTFees)}</Col>
                <Col xs={3}><strong>Taxes</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curTaxes)}</Col>
              </Row>
              {/* Row 9 */}
              <Row>
                <Col xs={3}><strong>Transportation</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curTransCost)}</Col>
                <Col xs={3}><strong>Warranty Type</strong></Col>
                <Col xs={3}>{vehicleToShow.strWarrType || ''}</Col>
              </Row>
              {/* Row 10 */}
              <Row>
                <Col xs={3}><strong>Warranty Sale</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curWarrSale)}</Col>
                <Col xs={3}><strong>Warranty Cost</strong></Col>
                <Col xs={3}>{formatCurrency(vehicleToShow.curWarrCost)}</Col>
              </Row>
              <Row>
              </Row>
              {/* Row 11 */}
              <Row>
                <Col xs={3}><strong>Production Date</strong></Col>
                <Col xs={3}>{formatDateUTC(vehicleToShow.dtProdDate) || ''}</Col>
                <Col xs={3}><strong>PDI Date</strong></Col>
                <Col xs={3}>{formatDateUTC(vehicleToShow.dtPDI) || ''}</Col>
              </Row>
              {/* Row 12 */}
              <Row>
                <Col xs={3}><strong>Received Date</strong></Col>
                <Col xs={3}>{formatDateUTC(vehicleToShow.dtRecvDate) || ''}</Col>
                <Col xs={3}><strong>Delivered Date</strong></Col>
                <Col xs={3}>{formatDateUTC(vehicleToShow.dtDelivDate) || ''}</Col>
              </Row>
              <Row>
                <Col xs={9}> </Col>
              </Row>
              {/* Row 13 */}
              <Row>
                <Col xs={3}><strong>Sale Date</strong></Col>
                <Col xs={3}>{formatDateUTC(vehicleToShow.dtSaleDate) || ''}</Col>
                <Col xs={3}><strong>Paid Date</strong></Col>
                <Col xs={3}>{formatDateUTC(vehicleToShow.dtPaidDate) || ''}</Col>
              </Row>
              <Row>
                <Col xs={9}> </Col>
              </Row>
              {/* Row 14 */}
              {(() => {
                const summary = summarizeUpfitters(vehicleToShow);
                const upfittersList = getUpfitterGroups(vehicleToShow);
                if (!summary.hasUpfitters) {
                  return (
                    <>
                      <Row>
                        <Col xs={3}><strong>Upfitter Name</strong></Col>
                        <Col xs={3}>{getUpfitter(vehicleToShow.strUpfitterNbr)?.strUpfitterName || ''}</Col>
                        <Col xs={3}><strong>Upfitter Status</strong></Col>
                        <Col xs={3}>{summary.fallbackLabel || getUpfitterStatus(vehicleToShow.strUpfitterStatus) || ''}</Col>
                      </Row>
                      <Row>
                        <Col xs={3}><strong>Sent To Upfitter</strong></Col>
                        <Col xs={3}>{formatMaybeDate(summary.fallbackSentDate) || ''}</Col>
                        <Col xs={3}><strong>Upfitter ETA Date</strong></Col>
                        <Col xs={3}>{formatMaybeDate(summary.fallbackEtaDate) || ''}</Col>
                      </Row>
                      <Row>
                        <Col xs={3}><strong>Upfitter Complete Date</strong></Col>
                        <Col xs={3}>{formatMaybeDate(summary.fallbackCompleteDate)}</Col>
                        <Col xs={3}></Col>
                        <Col xs={3}></Col>
                      </Row>
                    </>
                  );
                }

                return (
                  <>
                    <Row>
                      <Col xs={3}><strong>Upfitter Status</strong></Col>
                      <Col xs={3}>{summary.label || ''}</Col>
                      <Col xs={3}><strong>All Upfitters Complete Date</strong></Col>
                      <Col xs={3}>{formatMaybeDate(summary.completeDate) || ''}</Col>
                    </Row>
                    <Row>
                      <Col xs={3}><strong>Active Upfitter Sent Date</strong></Col>
                      <Col xs={3}>{formatMaybeDate(summary.sentDate) || ''}</Col>
                      <Col xs={3}><strong>Active Upfitter ETA Date</strong></Col>
                      <Col xs={3}>{formatMaybeDate(summary.etaDate) || ''}</Col>
                    </Row>
                    {upfittersList.length > 0 && (
                      <div className="mt-3">
                        <Table bordered hover size="sm" responsive>
                          <thead>
                            <tr>
                              <th>Upfitter</th>
                              <th>Status</th>
                              <th>Sent</th>
                              <th>ETA</th>
                              <th>Complete</th>
                            </tr>
                          </thead>
                          <tbody>
                            {summary.entries.map((entry, idx) => (
                              <tr key={idx}>
                                <td>{entry.upfitter || getUpfitter(entry.upfitterNbr)?.strUpfitterName || ''}</td>
                                <td>{entry.statusLabel || ''}</td>
                                <td>{formatMaybeDate(entry.dtSentToUpfitter)}</td>
                                <td>{formatMaybeDate(entry.dtUpfitterETA)}</td>
                                <td>{formatMaybeDate(entry.dtUpfitterComp)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    )}
                  </>
                );
              })()}
              <Row>
                <Col xs={9}> </Col>
              </Row>
              {/* Row 16 */}
              <Row>
                <Col xs={3}><strong>Billed CDK</strong></Col>
                <Col xs={3}>{vehicleToShow.bBillCDK ? 'Yes' : 'No'}</Col>
                <Col xs={3}><strong>Recall CDK</strong></Col>
                <Col xs={3}>{vehicleToShow.bRecall ? 'Yes' : 'No'}</Col>
              </Row>
              <Row>
                <Col xs={9}> </Col>
              </Row>
              {/* Row 17 */}
              <Row>
                <Col xs={3}><strong>Bill Notes</strong></Col>
                <Col xs={9}>{vehicleToShow.strBillNotes || ''}</Col>
              </Row>
            </div>
          )}
        </Modal.Body>
      </Modal>


      {/* Bulk Edit Modal */}
      <Modal show={showBulkEditModal} onHide={handleBulkEditHide} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Edit Vehicle(s)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <VehicleForm
            salesOrderNumber={allVehicles ? null : selectedOrder?.strSalesOrdNbr}
            vehicle={vehicleToEdit}
            onVehicleAdded={handleVehicleAdded}
            onVehicleUpdated={(updatedVehicle) => {
              handleVehicleUpdated(updatedVehicle);
              setShowBulkEditModal(false); // Close the modal after updating
              setSelectedVehicles([]);
              setSelectAll(false);
              setReload(reload + 1);
            }}
            onBulkEditSubmit={(updatedFields) => {
              handleBulkEditSubmit(updatedFields);
              setShowBulkEditModal(false); // Close the modal after bulk editing
              setSelectedVehicles([]);
              setReload(reload + 1);
            }}
            modelCodes={modelCodes}
          />
        </Modal.Body>
      </Modal>

      {/* Teams Progress Modal */}
      <Modal show={showTeamsModal} onHide={() => setShowTeamsModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create Teams Folders</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {teamsLoading ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
              <ProgressBar now={teamsProgress} label={`${teamsProgress}%`} className="mt-3" />
            </div>
          ) : (
            <div>Folders have been successfully created!</div>
          )}
        </Modal.Body>
      </Modal>
      <Modal show={showQuoteModal} onHide={() => setShowQuoteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Request Quote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <div>Vehicles selected: <strong>{notifyCounts.total}</strong></div>
            <div>Will request quotes for: <strong>{notifyCounts.withVin}</strong></div>
            {notifyCounts.noVin > 0 && (
              <div>Skipping (no VIN): <strong>{notifyCounts.noVin}</strong></div>
            )}
            {notifyCounts.deduped > 0 && (
              <div>Duplicate VINs merged: <strong>{notifyCounts.deduped}</strong></div>
            )}
          </div>

          <Form.Group controlId="quoteCustomerSelect">
            <Form.Label>Customer</Form.Label>
            <Form.Select
              value={selectedCustomerNbr}
              onChange={(e) => setSelectedCustomerNbr(e.target.value)}
            >
              {getCustomerOptionsForUser().length === 0 && (
                <option value="" disabled>No customers available</option>
              )}
              {getCustomerOptionsForUser().map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label} ({opt.value})
                </option>
              ))}
            </Form.Select>
            {getCustomerOptionsForUser().length === 0 && (
              <div className="text-danger mt-2">You don’t have any assigned customers.</div>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowQuoteModal(false)}>Cancel</Button>
          <Button
            variant="primary"
            onClick={sendQuoteEmail}
            disabled={!selectedCustomerNbr || notifyVehicles.length === 0}
          >
            Send
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showBillOutModal}
        onHide={() => setShowBillOutModal(false)}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Bill Out Sheet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {billOutVehicle && (
            <BillOutSheet
              vehicle={billOutVehicle}
              salesOrder={getSalesOrder(billOutVehicle.strSalesOrdNbr)}   
              customer={getCustomer(billOutVehicle.strSalesOrdNbr)}     
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );


}

export default VehicleList;
